/**
 * Master Muscles — Cart Sheet & global add-to-cart
 * Mobile: bottom sheet | Desktop: right drawer
 */
(function () {
  'use strict';

  var CFG = window.MM_CART_SHEET_CONFIG || {};
  var root = null;
  var isOpen = false;
  var lastAddedTitle = '';
  var skipGlobalHook = false;
  var cartCache = null;
  var pendingKeys = {};
  var lastUserLineOpAt = 0;
  var qtyTimers = {};
  var qtySafetyTimers = {};
  var lastRecsKey = '';
  var sddTimer = null;
  var actionsBound = false;
  var cartUpdateToken = 0;
  var cartFetchChain = Promise.resolve();
  var cartFetchSeq = 0;
  var cartMutChain = Promise.resolve();
  var pendingAddChain = Promise.resolve();
  var sheetUpdatingCount = 0;
  var productVariantsCache = {};
  var variantCompareCache = {};
  var dynamicShippingKey = '';
  var previousFocus = null;

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function formatMoney(cents) {
    if (typeof window.mmFormatMoneyHtml === 'function') {
      return window.mmFormatMoneyHtml(cents);
    }
    if (window.mmTaxConfig && typeof window.mmTaxConfig.formatWithTax === 'function') {
      return window.mmTaxConfig.formatWithTax(cents);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
    }
    return (cents / 1000).toFixed(3);
  }

  function localePrefix() {
    var p = window.location.pathname;
    var m = p.match(/^(\/[a-z]{2}(-[a-z]{2})?)\//i);
    return m ? m[1] : '';
  }

  function apiRoot() {
    if (window.MMRecommendations && typeof window.MMRecommendations.apiRoot === 'function') {
      return window.MMRecommendations.apiRoot();
    }
    if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
      var r = window.Shopify.routes.root;
      if (r.slice(-1) !== '/') r += '/';
      return r;
    }
    var prefix = localePrefix();
    return prefix ? prefix + '/' : '/';
  }

  function marketCountry() {
    var host = document.body || document.documentElement;
    var html = document.documentElement;
    var country = '';
    if (host && host.getAttribute) country = host.getAttribute('data-mm-country') || '';
    if (!country && html && html.getAttribute) country = html.getAttribute('data-mm-country') || '';
    if (!country) country = CFG.countryCode || '';

    var currency = '';
    if (html && html.getAttribute) currency = html.getAttribute('data-mm-currency') || '';
    try {
      currency = currency || localStorage.getItem('mm_display_currency_user') || '';
    } catch (e) {}
    if (String(currency).toUpperCase() === 'SAR') return 'SA';

    country = String(country || '').trim().toUpperCase();
    if (country) return country;

    return 'BH';
  }

  function isSaudiMarket() {
    return marketCountry() === 'SA';
  }

  function countryInList(raw, fallback) {
    var country = marketCountry();
    var list;
    if (raw !== undefined && raw !== null) {
      list = String(raw).trim();
      if (!list) return false;
    } else {
      list = String(fallback || '').trim();
      if (!list) return false;
    }
    if (list === '*') return true;
    return list.split(',').map(function (v) { return String(v || '').trim().toUpperCase(); }).some(function (code) {
      return code === '*' || code === country;
    });
  }

  function featureVisible(key, fallback) {
    return countryInList(CFG[key], fallback);
  }

  function hideTierGiftUi() {
    $$('[data-mm-tier-ladder]').forEach(function (el) {
      el.hidden = true;
    });
  }

  function openPerkDetails() {
    var details = root
      ? root.querySelector('.mm-cart-sheet__perk-more')
      : document.querySelector('#mm-cart-sheet .mm-cart-sheet__perk-more');
    if (!details) return;
    details.open = true;
    try {
      details.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } catch (e) {}
  }

  function handleGiftAction() {
    if (window.MMCartTierGifts && typeof window.MMCartTierGifts.openGiftOrDetails === 'function') {
      window.MMCartTierGifts.openGiftOrDetails(cartCache);
      return;
    }
    if (window.MMCartTierGifts && typeof window.MMCartTierGifts.canOpenPicker === 'function') {
      if (window.MMCartTierGifts.canOpenPicker(cartCache)) {
        if (typeof window.MMCartTierGifts.openPicker === 'function') {
          window.MMCartTierGifts.openPicker(cartCache);
          return;
        }
      } else {
        openPerkDetails();
        return;
      }
    }
    var giftEl = $('#mmCartSheetGift');
    if (giftEl && giftEl.classList.contains('is-unlocked') && typeof window.mmOpenGiftPopup === 'function') {
      window.mmOpenGiftPopup();
      return;
    }
    openPerkDetails();
  }

  function productPageUrl(product) {
    if (window.MMRecommendations && typeof window.MMRecommendations.productUrl === 'function') {
      return window.MMRecommendations.productUrl(product);
    }
    var handle = product && product.handle;
    if (!handle) return '#';
    return apiRoot() + 'products/' + handle;
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function compatText(key, fallback) {
    var messages = window.MM_COMPAT_I18N || {};
    return messages[key] || fallback;
  }

  function cartErrorRawText(err) {
    if (!err) return '';
    var value = err.description || err.message || err.error || '';
    if (typeof value !== 'string') return '';
    return value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 280);
  }

  function cartErrorWithReason(message, raw) {
    if (!raw || /^(failed to fetch|networkerror|load failed|timeout)$/i.test(raw)) return message;
    if (/cart api returned non-json/i.test(raw)) return message;
    return message + ' ' + compatText('cart_reason_prefix', 'Store details:') + ' ' + raw;
  }

  // "Sold out" is the one message a customer acts on by giving up, so the theme
  // may only say it when the store actually said it. A transport failure, a
  // timeout, or a 422 whose variant we re-checked and found in stock must never
  // be reported as a stock problem — that is what made every product look sold
  // out during a single bad session.
  var STOCK_WORDS = /sold out|out of stock|already sold|no longer available|نفد|نفذت|غير متوفر/;

  function cartErrorHadResponse(err) {
    return !!(err && parseInt(err.status || err.statusCode, 10));
  }

  function isStockCartError(err) {
    if (!err || err.__mmStockVerifiedAvailable) return false;
    if (!cartErrorHadResponse(err)) return false;
    return STOCK_WORDS.test(cartErrorRawText(err).toLowerCase());
  }

  function explainCartError(err) {
    var raw = cartErrorRawText(err);
    var lower = raw.toLowerCase();
    var status = parseInt(err && (err.status || err.statusCode), 10) || 0;

    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      return compatText('cart_offline', 'You are offline. Reconnect, then try again.');
    }
    if (typeof navigator !== 'undefined' && navigator.cookieEnabled === false) {
      return compatText('cart_not_saved', 'The cart could not be saved because cookies are blocked.');
    }
    // Re-checked against the live variant and it is in stock: the add failed for
    // another reason (stale cart session, blocked cookie, transient 422).
    if (err && err.__mmStockVerifiedAvailable) {
      return compatText('cart_retry', 'Could not add the item just now. Please try again.');
    }
    if (/timeout|timed out/.test(lower) || !status) {
      return compatText('cart_timeout', 'The connection is slow. Please try again.');
    }
    if (status === 429 || status === 503 || /too many requests|temporarily unavailable/.test(lower)) {
      return compatText('cart_busy', 'The store is temporarily busy. Wait a moment, then try again.');
    }
    if (/gift|هدية/.test(lower) && /limit|restricted|not eligible|غير مسموح|واحدة فقط/.test(lower)) {
      return cartErrorWithReason(
        compatText('cart_gift_restricted', 'This gift cannot be changed that way. Refresh the cart and choose an available gift.'),
        raw
      );
    }
    if (/country|market|region|shipping address|بلد|دولة|منطقة/.test(lower) && /unavailable|not available|not supported|غير متاح|غير مدعوم/.test(lower)) {
      return cartErrorWithReason(
        compatText('cart_country_unavailable', 'This product is not currently available in your country.'),
        raw
      );
    }
    if (isStockCartError(err)) {
      return cartErrorWithReason(
        compatText('cart_out_of_stock', 'This option is sold out or no longer available. Choose another option.'),
        raw
      );
    }
    if (/quantity|inventory|cannot add more|can't add more|maximum|not enough|كمية|المخزون|الحد الأقصى/.test(lower)) {
      return cartErrorWithReason(
        compatText('cart_quantity_unavailable', 'The requested quantity is unavailable. Reduce the quantity, then try again.'),
        raw
      );
    }
    if (status === 422 && raw) {
      return cartErrorWithReason(
        compatText('cart_error', 'Could not update the cart. Please try again.'),
        raw
      );
    }
    return compatText('cart_error', 'Could not update the cart. Please try again.');
  }

  function showSourceError(sourceEl, message) {
    if (!sourceEl || !sourceEl.parentNode || !message) return;
    var host = sourceEl.parentElement;
    var existing = host && host.querySelector('[data-mm-cart-inline-error]');
    if (!existing) {
      existing = document.createElement('p');
      existing.className = 'mm-cart-inline-error';
      existing.setAttribute('data-mm-cart-inline-error', '');
      existing.setAttribute('role', 'alert');
      existing.setAttribute('aria-live', 'assertive');
      sourceEl.insertAdjacentElement('afterend', existing);
    }
    existing.textContent = message;
    existing.hidden = false;
  }

  function clearSourceError(sourceEl) {
    if (!sourceEl || !sourceEl.parentElement) return;
    var existing = sourceEl.parentElement.querySelector('[data-mm-cart-inline-error]');
    if (existing) existing.remove();
  }

  function clearProductSelectionErrors() {
    document.querySelectorAll('[data-mm-cart-inline-error]').forEach(function (el) {
      el.remove();
    });
  }

  function cssAttrEscape(s) {
    if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
      return CSS.escape(String(s));
    }
    return String(s).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function getItemRow(key) {
    if (!root || !key) return null;
    return root.querySelector('.mm-cart-sheet__item[data-cart-key="' + cssAttrEscape(key) + '"]');
  }

  function clearItemBusy(key) {
    delete pendingKeys[key];
    clearTimeout(qtyTimers[key]);
    clearTimeout(qtySafetyTimers[key]);
    delete qtyTimers[key];
    delete qtySafetyTimers[key];
    var row = getItemRow(key);
    if (row) {
      row.classList.remove('mm-cart-sheet__item--updating', 'mm-cart-sheet__item--removing');
      var qty = row.querySelector('.mm-cart-sheet__qty');
      if (qty) qty.classList.remove('mm-cart-sheet__qty--busy');
      var picker = getVariantPicker(row);
      if (picker) picker.classList.remove('is-busy');
    }
  }

  function isCartPayload(data) {
    return data && Array.isArray(data.items) && typeof data.item_count === 'number';
  }

  function getCartIconEl() {
    return (
      document.querySelector('[data-mm-cart-trigger] .mm-action-icon') ||
      document.querySelector('.mm-action-link[href*="/cart"] .mm-action-icon') ||
      document.querySelector('.mm-cart-badge')?.closest('.mm-action-icon')
    );
  }

  function updateBadges(count, animate) {
    var n = parseInt(count, 10) || 0;
    document
      .querySelectorAll('.cart-count, [data-cart-count], .mm-cart-count, .mm-cart-badge, .mm-bottom-nav-badge')
      .forEach(function (el) {
        el.textContent = n;
        if (el.classList.contains('mm-cart-badge') || el.classList.contains('mm-bottom-nav-badge')) {
          el.style.display = n > 0 ? 'flex' : 'none';
        }
        if (animate) {
          el.classList.remove('mm-cart-badge--bounce');
          void el.offsetWidth;
          el.classList.add('mm-cart-badge--bounce');
        }
      });

    var titleCount = $('#mmCartSheetCount');
    if (titleCount) titleCount.textContent = n;

    syncClearAllBtn(n);

    if (animate) {
      var iconWrap = document.querySelector('[data-mm-cart-trigger]');
      if (iconWrap) {
        iconWrap.classList.remove('mm-cart-icon--pulse');
        void iconWrap.offsetWidth;
        iconWrap.classList.add('mm-cart-icon--pulse');
        setTimeout(function () {
          iconWrap.classList.remove('mm-cart-icon--pulse');
        }, 600);
      }
    }
  }

  function syncClearAllBtn(count) {
    var btn = $('#mmCartSheetClearAll');
    if (!btn) return;
    var n = typeof count === 'number' ? count : (cartCache && cartCache.item_count) || 0;
    btn.hidden = n <= 0;
    if (n <= 0) btn.disabled = false;
  }

  function clearAllCart() {
    var btn = $('#mmCartSheetClearAll');
    var count =
      (cartCache && cartCache.item_count) ||
      (root && root.querySelectorAll('.mm-cart-sheet__item').length) ||
      0;
    if (count <= 0) return;
    var msg = CFG.confirmClearAll || 'Remove all items from your cart?';
    if (!window.confirm(msg)) return;

    if (btn) btn.disabled = true;
    root.querySelectorAll('.mm-cart-sheet__item').forEach(function (row) {
      row.classList.add('mm-cart-sheet__item--removing');
    });
    setSheetUpdating(true, CFG.updating || 'Updating cart…');
    lastUserLineOpAt = Date.now();

    fetchCartJson('cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: '{}'
    })
      .then(function (cart) {
        if (!isCartPayload(cart)) {
          return fetchCartJson('cart.js');
        }
        return cart;
      })
      .then(function (cart) {
        applyCartUpdate(cart, { loadRecs: false });
        showSuccessBanner(CFG.cartUpdated || '');
      })
      .catch(function () {
        return fetchCartJson('cart.js')
          .then(function (fresh) {
            applyCartUpdate(fresh, { loadRecs: false });
          })
          .catch(function () {
            if (cartCache) applyCartUpdate(cartCache, { loadRecs: false });
          });
      })
      .then(function () {
        forceSheetUpdatingOff();
        if (btn) btn.disabled = false;
      });
  }

  function flyToCart(sourceEl, imageUrl) {
    if (!imageUrl || !sourceEl) return;
    var target = getCartIconEl();
    if (!target) return;

    var srcRect = sourceEl.getBoundingClientRect();
    var tgtRect = target.getBoundingClientRect();
    var fly = document.createElement('img');
    fly.className = 'mm-cart-fly';
    fly.src = imageUrl;
    fly.alt = '';
    fly.style.left = srcRect.left + srcRect.width / 2 - 22 + 'px';
    fly.style.top = srcRect.top + srcRect.height / 2 - 22 + 'px';
    fly.style.transition =
      'left 0.38s cubic-bezier(0.22, 1, 0.36, 1), top 0.38s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.32s ease, transform 0.38s cubic-bezier(0.22, 1, 0.36, 1)';
    document.body.appendChild(fly);

    requestAnimationFrame(function () {
      fly.style.left = tgtRect.left + tgtRect.width / 2 - 10 + 'px';
      fly.style.top = tgtRect.top + tgtRect.height / 2 - 10 + 'px';
      fly.style.opacity = '0.25';
      fly.style.transform = 'scale(0.3)';
    });

    setTimeout(function () {
      fly.remove();
    }, 400);
  }

  function cartApi(path) {
    return apiRoot() + String(path || '').replace(/^\//, '');
  }

  function cartPause(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms || 400);
    });
  }

  function fetchCartJson(path, opts, attempt) {
    attempt = attempt || 0;
    opts = opts || {};
    var headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    return fetch(cartApi(path), Object.assign({ credentials: 'same-origin' }, opts, { headers: headers }))
      .then(function (r) {
        return r.text().then(function (text) {
          var data = null;
          if (text) {
            try { data = JSON.parse(text); } catch (e) { data = null; }
          }
          if (data && typeof data === 'object') {
            if (!r.ok) {
              if ((r.status === 429 || r.status === 503) && attempt < 3) {
                return cartPause(1000 * Math.pow(2, attempt)).then(function () {
                  return fetchCartJson(path, opts, attempt + 1);
                });
              }
              data.status = r.status;
              throw data;
            }
            return data;
          }
          if ((r.status === 429 || r.status === 503) && attempt < 3) {
            return cartPause(1000 * Math.pow(2, attempt)).then(function () {
              return fetchCartJson(path, opts, attempt + 1);
            });
          }
          var err = new Error('Cart API returned non-JSON');
          err.status = r.status;
          throw err;
        });
      });
  }

  function fetchCart() {
    var seq = ++cartFetchSeq;
    var next = cartFetchChain.then(function () {
      return fetchCartJson('cart.js');
    });
    cartFetchChain = next.catch(function () {});
    return next.then(function (cart) {
      if (seq !== cartFetchSeq) return cartCache || cart;
      return cart;
    });
  }

  function productHandleFromUrl(url) {
    if (!url) return '';
    var m = String(url).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function withTax(cents) {
    if (CFG.taxEnabled && CFG.taxRate) {
      return Math.round(cents * CFG.taxRate);
    }
    return cents;
  }

  function getMoneyDivisor() {
    var d = parseInt(CFG.moneyDivisor, 10);
    if (d === 100 || d === 1000) return d;
    var attr = parseInt(document.documentElement.getAttribute('data-mm-money-divisor'), 10);
    if (attr === 100 || attr === 1000) return attr;
    return 1000;
  }

  /** Plain text — amount already includes tax (no HTML, no double tax). */
  function formatMoneyTaxed(taxedMinor) {
    var div = getMoneyDivisor();
    if (typeof window.mmFormatMoneyTaxed === 'function') {
      return window.mmFormatMoneyTaxed(taxedMinor, div);
    }
    var dec = div === 1000 ? 3 : 2;
    return (taxedMinor / div).toFixed(dec) + ' BHD';
  }

  function formatMoneyCompact(taxedMinor) {
    return String(formatMoneyTaxed(taxedMinor) || '')
      .replace(/<[^>]+>/g, '')
      .replace(/\s*[A-Z]{3}\s*$/i, '')
      .trim();
  }

  function getShippingEligibleTotal(cart) {
    if (window.mmShippingEligibility && typeof window.mmShippingEligibility.calculateEligibleTotalSync === 'function') {
      return window.mmShippingEligibility.calculateEligibleTotalSync(cart).eligible;
    }
    return (cart.items || []).reduce(function (sum, item) {
      return sum + (item.final_line_price || 0);
    }, 0);
  }

  function decodeEntities(str) {
    if (!str) return '';
    var s = String(str);
    if (s.indexOf('&') === -1) return s;
    var ta = document.createElement('textarea');
    ta.innerHTML = s;
    return ta.value;
  }

  function replaceAmount(str, taxedRemainingMinor) {
    if (!str) return '';
    var formatted = String(formatMoneyTaxed(taxedRemainingMinor) || '')
      .replace(/<[^>]+>/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    return decodeEntities(str)
      .replace(/\[amount\]/g, formatted)
      .replace(/\{\{\s*amount\s*\}\}/g, formatted);
  }

  function formatRemainingAmount(remainingMinor) {
    var n = parseInt(remainingMinor, 10);
    if (!isFinite(n) || n < 0) n = 0;
    var raw = '';
    try {
      raw = String(formatMoneyTaxed(n) || '');
    } catch (e) {
      raw = '';
    }
    raw = raw.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
    if (raw) return raw;
    var div = getMoneyDivisor();
    var dec = div === 1000 ? 3 : 2;
    return (n / div).toFixed(dec);
  }

  function setPerkRemaining(msgEl, amountId, remainingMinor, suffixKey, suffixFallback, unlockedText) {
    if (!msgEl) return;
    if (remainingMinor <= 0) {
      msgEl.innerHTML =
        '<span class="mm-cart-sheet__perk-status">' +
        escapeHtml(decodeEntities(unlockedText || '')) +
        '</span>';
      return;
    }
    var amount = formatRemainingAmount(remainingMinor);
    var suffix = decodeEntities(
      (suffixKey && CFG[suffixKey]) || suffixFallback || ''
    );
    msgEl.innerHTML =
      '<strong class="mm-cart-sheet__perk-amount" id="' +
      escapeHtml(amountId) +
      '">' +
      escapeHtml(amount) +
      '</strong> ' +
      '<span class="mm-cart-sheet__perk-tail">' +
      escapeHtml(suffix) +
      '</span>';
  }

  function renderShipRemainingHtml(remainingMinor) {
    return (
      '<strong class="mm-cart-sheet__perk-amount">' +
      escapeHtml(formatRemainingAmount(remainingMinor)) +
      '</strong> ' +
      '<span class="mm-cart-sheet__perk-tail">' +
      escapeHtml(decodeEntities(CFG.shippingAddSuffix || 'to free ship')) +
      '</span>'
    );
  }

  /**
   * A country the storefront can actually sell to.
   *
   * prepare_shipping_rates.json is NOT a read: it writes the destination onto
   * the live cart. Sending a country that has no market leaves the cart bound
   * to an address Shopify cannot fulfil, and from that point every single
   * cart/add.js answers "The product '…' is already sold out" — for every
   * product, for the whole session, even after the cart is emptied. Quoting a
   * rate is never worth that, so the estimator refuses to run off-market.
   */
  function isSellableCountry(country) {
    var code = String(country || '').trim().toUpperCase();
    if (!code) return false;
    var allowed = CFG.sellableCountries;
    // No list published (older config): trust only the storefront's own country.
    if (!Array.isArray(allowed) || !allowed.length) {
      return code === String(CFG.countryCode || '').trim().toUpperCase();
    }
    for (var i = 0; i < allowed.length; i++) {
      if (String(allowed[i]).trim().toUpperCase() === code) return true;
    }
    return false;
  }

  function shippingRatesCountry() {
    var country = String(CFG.dynamicShippingCountry || '').trim().toUpperCase();
    return isSellableCountry(country) ? country : '';
  }

  function shippingRatesQuery() {
    var country = shippingRatesCountry();
    if (!country) return '';
    var params = new URLSearchParams();
    params.set('shipping_address[country_code]', country);
    params.set('shipping_address[country]', country === 'SA' ? 'Saudi Arabia' : country);
    return params.toString();
  }

  function formatShippingRate(rate) {
    if (typeof window.mmFormatShippingRate === 'function') {
      return window.mmFormatShippingRate(rate, {
        country: CFG.dynamicShippingCountry || marketCountry(),
        displayCurrency: marketCountry() === 'SA' ? 'SAR' : undefined,
      });
    }
    if (!rate) return '';
    var price = rate.price || rate.price_min || rate.presentment_price;
    if (price == null || price === '') return '';
    return String(price);
  }

  function pollShippingRates(query, attempts) {
    return cartPause(650).then(function () {
      return fetch(cartApi('cart/async_shipping_rates.json?' + query), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
    }).then(function (r) {
      if (!r || !r.ok) return null;
      return r.json();
    }).then(function (data) {
      var rates = data && (data.shipping_rates || data.rates);
      if (!Array.isArray(rates) || !rates.length) return null;
      return rates[0];
    }).catch(function () {
      return null;
    }).then(function (rate) {
      if (rate || attempts <= 1) return rate;
      return pollShippingRates(query, attempts - 1);
    });
  }

  function readShippingRates() {
    var query = shippingRatesQuery();
    if (!query) return Promise.resolve(null); // off-market: show the static fallback copy instead
    return fetch(cartApi('cart/prepare_shipping_rates.json?' + query), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).catch(function () {
      return null;
    }).then(function () {
      return pollShippingRates(query, 4);
    });
  }

  function renderDynamicShipping(cart) {
    var wrap = $('#mmCartSheetDynamicShipping');
    var text = $('#mmCartSheetDynamicShippingText');
    if (!wrap || !text) return;
    var targetCountry = String(CFG.dynamicShippingCountry || '').toUpperCase();
    if (
      !CFG.dynamicShippingEnabled ||
      !targetCountry ||
      !isSellableCountry(targetCountry) ||
      marketCountry() !== targetCountry ||
      !cart.items ||
      !cart.items.length
    ) {
      wrap.hidden = true;
      return;
    }

    wrap.hidden = false;
    var key = [
      cart.item_count || 0,
      cart.total_price || 0,
      cart.total_weight || 0,
      (cart.items || []).map(function (item) {
        return [item.variant_id, item.quantity].join(':');
      }).join(',')
    ].join('|');

    if (key === dynamicShippingKey && wrap.getAttribute('data-rate-ready') === '1') return;
    dynamicShippingKey = key;
    wrap.removeAttribute('data-rate-ready');
    text.textContent = CFG.dynamicShippingLoading || 'Calculating shipping by cart weight...';

    readShippingRates().then(function (rate) {
      var rateText = formatShippingRate(rate);
      wrap.setAttribute('data-rate-ready', '1');
      if (rateText) {
        text.textContent = (CFG.dynamicShippingEstimated || 'Current shipping rate:') + ' ' + rateText;
      } else {
        text.textContent = CFG.dynamicShippingFallback || 'Shipping changes by weight and appears at checkout.';
      }
    });
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function getStoreNow() {
    var tz = CFG.timezone || 'Asia/Bahrain';
    try {
      return new Date(new Date().toLocaleString('en-US', { timeZone: tz }));
    } catch (e) {
      return new Date();
    }
  }

  function updateSdd() {
    var wrap = $('#mmCartSheetSdd');
    var textEl = $('#mmCartSheetSddText');
    var timerEl = $('#mmCartSheetSddTimer');
    var saWrap = $('#mmCartSheetSaDelivery');
    var saText = $('#mmCartSheetSaDeliveryText');

    var showStaticDelivery = featureVisible('staticDeliveryCountries');
    var showSdd = featureVisible('sddCountries');

    if (!showStaticDelivery && !showSdd) {
      if (wrap) wrap.remove();
      if (saWrap) saWrap.remove();
      return;
    }

    if (showStaticDelivery) {
      if (wrap) wrap.hidden = true;
      if (timerEl) timerEl.hidden = true;
      if (saWrap) {
        saWrap.hidden = false;
        if (saText) saText.textContent = CFG.saDeliveryText || '';
      }
      return;
    }

    if (saWrap) saWrap.hidden = true;

    if (!showSdd) {
      if (wrap) wrap.hidden = true;
      if (timerEl) timerEl.hidden = true;
      return;
    }

    if (!textEl || !wrap) return;

    if (wrap) wrap.hidden = false;

    var cutoffHour = CFG.sddHour || 20;
    var now = getStoreNow();
    var cutoff = new Date(now.getTime());
    cutoff.setHours(cutoffHour, 0, 0, 0);

    if (now >= cutoff) {
      if (timerEl) timerEl.hidden = true;
      textEl.textContent = CFG.sddShortTomorrow || CFG.sddTomorrow || 'Order before 8 PM tomorrow to get same-day delivery';
      wrap.setAttribute('title', CFG.sddTomorrow || CFG.sddTitle || 'Order before 8 PM tomorrow for same-day delivery');
      if (wrap) wrap.classList.add('mm-cart-sheet__sdd--closed');
      return;
    }

    if (wrap) wrap.classList.remove('mm-cart-sheet__sdd--closed');
    var diff = cutoff.getTime() - now.getTime();
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);

    var hEl = $('#mmCartSheetSddH');
    var mEl = $('#mmCartSheetSddM');
    var sEl = $('#mmCartSheetSddS');
    if (timerEl && hEl && mEl && sEl) {
      timerEl.hidden = false;
      hEl.textContent = pad2(h);
      mEl.textContent = pad2(m);
      sEl.textContent = pad2(s);
    }

    textEl.textContent = CFG.sddShort || 'Order before 8 PM to get same-day delivery';
    wrap.setAttribute('title', CFG.sddTitle || 'Order before 8 PM for same-day delivery');
  }

  function cacheVariantComparePrices(product) {
    if (!product || !product.variants) return;
    product.variants.forEach(function (v) {
      var price = parseInt(v.price, 10) || 0;
      var compareAt = parseInt(v.compare_at_price, 10) || 0;
      if (compareAt > price) variantCompareCache[v.id] = compareAt;
    });
  }

  function getCompareAtUnit(item, row) {
    var fromCart = parseInt(item.compare_at_price, 10) || 0;
    if (fromCart > 0) return fromCart;

    var vid = item.variant_id;
    if (vid && variantCompareCache[vid]) return variantCompareCache[vid];

    if (row) {
      var fromRow = parseInt(row.getAttribute('data-compare-at-unit'), 10) || 0;
      if (fromRow > 0) return fromRow;
    }

    return 0;
  }

  function lineDiscountTotal(item) {
    var sum = 0;
    (item.line_level_discount_allocations || []).forEach(function (alloc) {
      sum += alloc.amount || 0;
    });
    return sum;
  }

  function lineIsFullyDiscounted(item) {
    var qty = item.quantity || 1;
    var finalLine = item.final_line_price != null
      ? item.final_line_price
      : (item.price || 0) * qty;
    if (finalLine <= 0) return true;
    var originalLine = item.original_line_price != null
      ? item.original_line_price
      : (item.price || 0) * qty;
    if (originalLine > 0 && lineDiscountTotal(item) >= originalLine) return true;
    return false;
  }

  function isTierGiftLine(item) {
    if (!item) return false;
    var props = item.properties || {};
    return props._gift === 'true';
  }

  function normVariantId(id) {
    return String(id || '').split('/').pop();
  }

  function parseFlashDeals(cart) {
    if (!cart || !cart.attributes) return [];
    var raw = cart.attributes._flash_deals_data;
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function getFlashDealForItem(item, cart) {
    if (!item) return null;
    var vid = normVariantId(item.variant_id);
    var deals = parseFlashDeals(cart || cartCache);
    var best = null;
    for (var i = 0; i < deals.length; i++) {
      var d = deals[i];
      if (!d || !d.variantId) continue;
      if (normVariantId(d.variantId) !== vid) continue;
      if (d.type !== 'wheel' && d.type !== 'flash') continue;
      var pct = parseFloat(d.discountPercent) || 0;
      if (!best || pct > (parseFloat(best.discountPercent) || 0)) best = d;
    }
    return best;
  }

  function computeFlashDealPricing(item, deal) {
    if (!item || !deal) return null;
    var qty = item.quantity || 1;
    var unit = item.original_price != null ? item.original_price : (item.price || 0);
    var originalLine = item.original_line_price != null ? item.original_line_price : unit * qty;
    var pct = Math.min(100, Math.max(0, parseFloat(deal.discountPercent) || 0));
    var dealQty = Math.max(1, parseInt(deal.quantity, 10) || 1);
    var discountedUnits = Math.min(qty, dealQty);
    var fullUnits = Math.max(0, qty - discountedUnits);
    var saleLine = Math.round(fullUnits * unit + discountedUnits * unit * (1 - pct / 100));
    if (deal.isFreeGift && pct >= 100) {
      saleLine = Math.round(fullUnits * unit);
    }
    if (saleLine >= originalLine) return null;
    var message = deal.type === 'wheel'
      ? (pct >= 100 || deal.isFreeGift ? 'Wheel Gift' : 'Wheel Prize')
      : 'Flash Deal';
    return {
      hasSale: true,
      saleLine: saleLine,
      compareLine: originalLine,
      compareAtUnit: unit,
      saved: originalLine - saleLine,
      isFlashDeal: true,
      dealMessage: message,
    };
  }

  function getItemPricing(item, row) {
    var qty = item.quantity || 1;
    var props = item.properties || {};
    var finalLine = item.final_line_price != null
      ? item.final_line_price
      : (item.price || 0) * qty;
    var originalLine = item.original_line_price != null
      ? item.original_line_price
      : (item.price || 0) * qty;

    if (isTierGiftLine(item)) {
      var confirmed = lineIsFullyDiscounted(item);
      return {
        hasSale: confirmed,
        saleLine: confirmed ? 0 : finalLine,
        compareLine: originalLine,
        compareAtUnit: qty > 0 ? Math.round(originalLine / qty) : 0,
        saved: confirmed ? originalLine : Math.max(0, originalLine - finalLine),
        isGift: true,
        giftConfirmed: confirmed
      };
    }
    var finalLine = item.final_line_price || 0;
    var unitFinal = item.final_price || Math.round(finalLine / qty) || 0;
    var compareAtUnit = getCompareAtUnit(item, row);

    if (compareAtUnit > unitFinal) {
      var compareLine = compareAtUnit * qty;
      if (compareLine > finalLine) {
        return {
          hasSale: true,
          saleLine: finalLine,
          compareLine: compareLine,
          compareAtUnit: compareAtUnit,
          saved: compareLine - finalLine,
        };
      }
    }

    if (item.original_line_price > finalLine) {
      return {
        hasSale: true,
        saleLine: finalLine,
        compareLine: item.original_line_price,
        compareAtUnit: Math.round(item.original_line_price / qty),
        saved: item.original_line_price - finalLine,
      };
    }

    var flashDeal = getFlashDealForItem(item, cartCache);
    if (flashDeal) {
      var projected = computeFlashDealPricing(item, flashDeal);
      if (projected) return projected;
    }

    return { hasSale: false, saleLine: finalLine, compareAtUnit: 0 };
  }

  function refreshItemPriceRow(item) {
    if (!item || !item.key) return;
    var row = getItemRow(item.key);
    if (!row) return;
    var prices = row.querySelector('.mm-cart-sheet__item-prices');
    if (!prices) return;
    var pricing = getItemPricing(item, row);
    prices.outerHTML = buildItemPriceHtml(item, row);
    if (pricing.hasSale && pricing.compareAtUnit) {
      row.setAttribute('data-compare-at-unit', pricing.compareAtUnit);
    }
  }

  function enrichCartItemPrices(cart) {
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve();

    var jobs = cart.items.map(function (item) {
      var row = getItemRow(item.key);
      if (getItemPricing(item, row).hasSale) return Promise.resolve();

      var handle = item.handle || (row && row.getAttribute('data-product-handle'));
      if (!handle) return Promise.resolve();

      return fetchProductVariants(handle).then(function (product) {
        if (!product) return;
        cacheVariantComparePrices(product);
        refreshItemPriceRow(item);
      });
    });

    return Promise.all(jobs);
  }

  function buildItemPriceHtml(item, row) {
    var pricing = getItemPricing(item, row);
    var html = '<div class="mm-cart-sheet__item-prices">';

    if (pricing.isGift) {
      if (pricing.giftConfirmed) {
        html +=
          '<span class="mm-cart-sheet__price-sale">' +
          escapeHtml((document.documentElement.lang || '').indexOf('ar') === 0 ? 'مجاني' : 'FREE') +
          '</span>';
        if (pricing.compareLine > 0) {
          html += '<span class="mm-cart-sheet__price-compare">' + formatMoney(pricing.compareLine) + '</span>';
        }
      } else {
        html += '<span class="mm-cart-sheet__price-current">' + formatMoney(pricing.saleLine) + '</span>';
        if (pricing.compareLine > pricing.saleLine) {
          html += '<span class="mm-cart-sheet__price-compare">' + formatMoney(pricing.compareLine) + '</span>';
        }
      }
    } else if (pricing.hasSale) {
      html +=
        '<div class="mm-cart-sheet__price-row">' +
        '<span class="mm-cart-sheet__price-label">' +
        escapeHtml(CFG.priceAfter || 'After') +
        '</span>' +
        '<span class="mm-cart-sheet__price-sale">' +
        formatMoney(pricing.saleLine) +
        '</span></div>' +
        '<div class="mm-cart-sheet__price-row">' +
        '<span class="mm-cart-sheet__price-label">' +
        escapeHtml(CFG.priceBefore || 'Before') +
        '</span>' +
        '<span class="mm-cart-sheet__price-compare">' +
        formatMoney(pricing.compareLine) +
        '</span></div>' +
        '<span class="mm-cart-sheet__price-saved">' +
        escapeHtml(CFG.youSave || 'You save') +
        ' ' +
        formatMoney(pricing.saved) +
        '</span>';
    } else {
      html += '<span class="mm-cart-sheet__price-current">' + formatMoney(pricing.saleLine) + '</span>';
    }

    if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
      item.line_level_discount_allocations.forEach(function (alloc) {
        var app = alloc.discount_application || {};
        var title = app.title || 'Discount';
        if (pricing.isGift && !/cart gift|gift reward/i.test(title)) return;
        html +=
          '<span class="mm-cart-sheet__discount-pill">🏷️ ' +
          escapeHtml(title) +
          '</span>';
      });
    } else if (pricing.isFlashDeal && pricing.dealMessage) {
      html +=
        '<span class="mm-cart-sheet__discount-pill">🏷️ ' +
        escapeHtml(pricing.dealMessage) +
        '</span>';
    }

    html += '</div>';
    return html;
  }

  function renderIncentives(cart) {
    var wrap = $('#mmCartSheetIncentives');
    if (!wrap) return;

    if (!cart.items || !cart.items.length) {
      wrap.hidden = true;
      renderDynamicShipping(cart);
      return;
    }
    wrap.hidden = false;
    renderDynamicShipping(cart);

    var showShipping = featureVisible('freeShippingCountries');
    var showGift = featureVisible('giftCountries');
    var shipVisible = $('#mmCartSheetShip');
    var shipNoticeVisible = $('#mmCartSheetShipNotice');
    if (shipVisible) shipVisible.hidden = !showShipping;
    if (shipNoticeVisible && !showShipping) shipNoticeVisible.hidden = true;
    var appTierGiftsActive = window.MMCartTierGifts && typeof window.MMCartTierGifts.isActive === 'function' && window.MMCartTierGifts.isActive();

    var progressOpts = {
      threshold: CFG.freeShippingThreshold || (window.__MM_FS_CONFIG__ && window.__MM_FS_CONFIG__.threshold) || 2000,
      taxEnabled: CFG.taxEnabled != null ? CFG.taxEnabled : !!(window.__MM_FS_CONFIG__ && window.__MM_FS_CONFIG__.taxEnabled),
      taxRate: CFG.taxRate || (window.__MM_FS_CONFIG__ && window.__MM_FS_CONFIG__.taxRate) || 1
    };

    function applyIncentives(shipProgress) {
      var shipEl = $('#mmCartSheetShip');
      var shipMsg = $('#mmCartSheetShipMsg');
      var shipFill = $('#mmCartSheetShipFill');
      var shipNotice = $('#mmCartSheetShipNotice');
      if (shipEl && shipMsg && shipFill && showShipping) {
        var wasUnlocked = shipEl.classList.contains('is-unlocked');
        var shipWarn = $('#mmCartSheetShipWarn');
        if (shipProgress.unlocked) {
          shipEl.classList.add('is-unlocked');
          setPerkRemaining(
            shipMsg,
            'mmCartSheetShipAmount',
            0,
            null,
            null,
            CFG.shippingUnlockedShort || 'Free ship'
          );
          shipEl.setAttribute('title', decodeEntities(CFG.shippingUnlocked || 'Free shipping unlocked'));
          if (!wasUnlocked) shipEl.classList.add('mm-cart-sheet__incentive--celebrate');
        } else {
          shipEl.classList.remove('is-unlocked', 'mm-cart-sheet__incentive--celebrate');
          setPerkRemaining(
            shipMsg,
            'mmCartSheetShipAmount',
            shipProgress.remaining,
            'shippingAddSuffix',
            'to free ship',
            null
          );
          shipEl.setAttribute(
            'title',
            replaceAmount(CFG.shippingRemaining || 'Add [amount] more for FREE shipping!', shipProgress.remaining)
          );
        }
        shipFill.style.width = shipProgress.progress + '%';
        shipEl.classList.toggle('has-exclusion', !!shipProgress.hasExcluded);
        if (shipWarn) {
          shipWarn.hidden = !shipProgress.hasExcluded;
          shipWarn.setAttribute(
            'title',
            decodeEntities(
              CFG.shippingExclusionNotice || 'Some items do not count toward free shipping'
            )
          );
        }
      }
      if (shipNotice && showShipping) {
        shipNotice.hidden = !shipProgress.hasExcluded;
        var noticeText = $('#mmCartSheetShipNoticeText');
        var noticeCopy = decodeEntities(
          CFG.shippingExclusionNotice ||
            'Some items do not count toward free shipping (+20 BD applies)'
        );
        if (noticeText) noticeText.textContent = noticeCopy;
        else if (shipProgress.hasExcluded) {
          shipNotice.textContent = noticeCopy;
        }
      }

      var giftEl = $('#mmCartSheetGift');
      var giftMsg = $('#mmCartSheetGiftMsg');
      var giftFill = $('#mmCartSheetGiftFill');
      if (giftEl) giftEl.hidden = !showGift;
      if (!showGift) hideTierGiftUi();
      if (appTierGiftsActive || !showGift) {
        updateSdd();
        return;
      }
      if (giftEl && giftMsg && giftFill) {
        var div = getMoneyDivisor();
        var giftGoalBhd = parseFloat(CFG.giftGoalBhd) || 50;
        var giftThresholdBase = CFG.giftThreshold || giftGoalBhd * div;
        if (div === 100 && giftThresholdBase >= giftGoalBhd * 1000) {
          giftThresholdBase = giftGoalBhd * div;
        }
        if (giftThresholdBase > 0) {
          var giftCompareThreshold = giftThresholdBase;
          var giftTotalCompare = cart.total_price || 0;
          var giftRemaining = Math.max(0, giftCompareThreshold - giftTotalCompare);
          var giftProgress =
            giftCompareThreshold > 0
              ? Math.min(100, Math.round((giftTotalCompare * 100) / giftCompareThreshold))
              : 0;
          var giftWas = giftEl.classList.contains('is-unlocked');
          if (giftRemaining <= 0) {
            giftEl.classList.add('is-unlocked');
            setPerkRemaining(
              giftMsg,
              'mmCartSheetGiftAmount',
              0,
              null,
              null,
              CFG.giftUnlockedShort || 'Gift ready'
            );
            giftEl.setAttribute('title', CFG.giftUnlocked || 'FREE gift unlocked!');
            if (!giftWas) giftEl.classList.add('mm-cart-sheet__incentive--celebrate');
          } else {
            giftEl.classList.remove('is-unlocked', 'mm-cart-sheet__incentive--celebrate');
            setPerkRemaining(
              giftMsg,
              'mmCartSheetGiftAmount',
              giftRemaining,
              'giftAddSuffix',
              'to gift',
              null
            );
            giftEl.setAttribute(
              'title',
              replaceAmount(CFG.giftRemaining || 'Add [amount] more for a FREE gift!', giftRemaining)
            );
          }
          giftFill.style.width = giftProgress + '%';
        }
      }

      updateSdd();
    }

    function buildLocalShippingProgress() {
      if (
        window.mmShippingEligibility &&
        typeof window.mmShippingEligibility.calculateEligibleTotalSync === 'function' &&
        typeof window.mmShippingEligibility.buildProgressFromEligible === 'function'
      ) {
        var syncResult = window.mmShippingEligibility.calculateEligibleTotalSync(cart);
        return window.mmShippingEligibility.buildProgressFromEligible(
          syncResult.eligible,
          syncResult.hasExcluded,
          progressOpts
        );
      }
      var threshold = parseInt(progressOpts.threshold, 10) || 0;
      var taxEnabled = !!progressOpts.taxEnabled;
      var taxRate = parseFloat(progressOpts.taxRate) || 1;
      var eligiblePreTax = getShippingEligibleTotal(cart);
      var eligibleCompare = taxEnabled ? Math.round(eligiblePreTax * taxRate) : eligiblePreTax;
      var remaining = Math.max(0, threshold - eligibleCompare);
      return {
        remaining: remaining,
        progress: threshold > 0 ? Math.min(100, Math.round((eligibleCompare * 100) / threshold)) : 0,
        unlocked: remaining <= 0,
        hasExcluded: false
      };
    }

    function runProgress() {
      applyIncentives(buildLocalShippingProgress());
      if (window.mmShippingEligibility && typeof window.mmShippingEligibility.refreshFromCart === 'function') {
        window.mmShippingEligibility.refreshFromCart(cart, progressOpts).then(function (shipProgress) {
          if (shipProgress) applyIncentives(shipProgress);
        }).catch(function () {});
      }
    }

    runProgress();
  }

  function renderDiscounts(cart) {
    var discountWrap = $('#mmCartSheetDiscount');
    if (discountWrap) discountWrap.hidden = !featureVisible('discountCountries');
    if (!featureVisible('discountCountries')) return;
    var appliedWrap = $('#mmCartSheetDiscountApplied');
    if (!appliedWrap) return;

    var codes = cartDiscountCodes(cart);

    if (!codes.length) {
      appliedWrap.hidden = true;
      appliedWrap.innerHTML = '';
      return;
    }

    appliedWrap.hidden = false;
    if (discountWrap) discountWrap.open = true;
    var html = '';
    codes.forEach(function (code) {
      html +=
        '<div class="mm-cart-sheet__discount-tag">' +
        '<span>🏷️ ' +
        escapeHtml(code) +
        '</span>' +
        '<button type="button" data-mm-remove-discount="' +
        escapeHtml(code) +
        '" aria-label="' +
        escapeHtml(compatText('gift_discount_remove_code', 'Remove discount code')) +
        '">×</button></div>';
    });
    appliedWrap.innerHTML = html;
  }

  function normalizedDiscountCode(value) {
    return String(value || '').trim().toLowerCase();
  }

  function cartDiscountCodes(cart) {
    var codes = [];
    ((cart && cart.discount_codes) || []).forEach(function (discount) {
      if (discount && discount.applicable !== false && discount.code) codes.push(discount.code);
    });
    ((cart && cart.cart_level_discount_applications) || []).forEach(function (discount) {
      if (discount && discount.type === 'discount_code' && discount.title) codes.push(discount.title);
    });
    return codes.filter(function (code, index, list) {
      var normalized = normalizedDiscountCode(code);
      return normalized && list.findIndex(function (candidate) {
        return normalizedDiscountCode(candidate) === normalized;
      }) === index;
    });
  }

  function renderDiscountEligibility(cart) {
    if (!root) return;
    root.querySelectorAll('.mm-cart-sheet__discount-excluded').forEach(function (badge) {
      badge.remove();
    });

    var activeCodes = cartDiscountCodes(cart);
    if (!activeCodes.length || !cart || !cart.items) return;
    var allocatedCodes = {};
    cart.items.forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        var app = allocation && allocation.discount_application;
        if (app && app.type === 'discount_code' && app.title) {
          allocatedCodes[normalizedDiscountCode(app.title)] = true;
        }
      });
    });

    var partialCodes = activeCodes.filter(function (code) {
      return !!allocatedCodes[normalizedDiscountCode(code)];
    });
    if (!partialCodes.length) return;

    cart.items.forEach(function (item) {
      var lineCodes = {};
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        var app = allocation && allocation.discount_application;
        if (app && app.type === 'discount_code' && app.title) {
          lineCodes[normalizedDiscountCode(app.title)] = true;
        }
      });
      var excluded = partialCodes.filter(function (code) {
        return !lineCodes[normalizedDiscountCode(code)];
      });
      if (!excluded.length) return;
      var row = getItemRow(item.key);
      var prices = row && row.querySelector('.mm-cart-sheet__item-prices');
      if (!prices) return;
      var badge = document.createElement('span');
      badge.className = 'mm-cart-sheet__discount-excluded';
      badge.textContent = compatText('discount_item_excluded', 'This item is not included in the code');
      badge.title = excluded.join(', ');
      prices.appendChild(badge);
    });
  }

  function describeDiscountFailure(cart, previousCart, code) {
    var attributes = (cart && cart.attributes) || {};
    if (String(attributes._mm_block_discount_codes || '').toLowerCase() === 'true') {
      return compatText('discount_app_conflict', 'This code cannot be combined with the current automatic offer.');
    }
    var otherCodes = cartDiscountCodes(previousCart).filter(function (candidate) {
      return normalizedDiscountCode(candidate) !== normalizedDiscountCode(code);
    });
    if (otherCodes.length) {
      return compatText('discount_conflict', 'This code cannot be combined with a discount already applied.');
    }
    return compatText('discount_not_applicable', 'The code is recognised, but this cart does not meet its conditions.');
  }

  function showDiscountMsg(text, type) {
    var el = $('#mmCartSheetDiscountMsg');
    if (!el) return;
    var discountWrap = $('#mmCartSheetDiscount');
    if (discountWrap) discountWrap.open = true;
    el.hidden = false;
    el.textContent = text;
    el.className = 'mm-cart-sheet__discount-msg mm-cart-sheet__discount-msg--' + (type || 'info');
    clearTimeout(el._t);
    if (type !== 'error') {
      el._t = setTimeout(function () {
        el.hidden = true;
      }, 4000);
    }
  }

  function applyDiscount() {
    if (!featureVisible('discountCountries')) return;
    var input = $('#mmCartSheetDiscountInput');
    var btn = $('#mmCartSheetDiscountBtn');
    if (!input || !btn) return;

    var code = input.value.trim();
    if (!code) {
      input.classList.add('mm-cart-sheet__discount-input--error');
      showDiscountMsg(CFG.discountEmpty || 'Enter a discount code', 'error');
      return;
    }
    input.classList.remove('mm-cart-sheet__discount-input--error');
    btn.classList.add('is-loading');
    btn.disabled = true;
    input.disabled = true;
    setSheetUpdating(true, CFG.updating || 'Updating cart…');

    var previousCart = null;
    fetchCartJson('cart.js')
      .then(function (cart) {
        previousCart = cart;
        var existing = [];
        if (cart.cart_level_discount_applications) {
          cart.cart_level_discount_applications.forEach(function (d) {
            if (d.type === 'discount_code') existing.push(d.title);
          });
        }
        existing.push(code);
        return fetchCartJson('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: existing.join(',') }),
        });
      })
      .then(function (data) {
        var matched = null;
        if (data.discount_codes) {
          data.discount_codes.forEach(function (d) {
            if (normalizedDiscountCode(d.code) === normalizedDiscountCode(code)) matched = d;
          });
        }
        if (matched && matched.applicable !== false) {
          input.value = '';
          showDiscountMsg(CFG.discountSuccess || 'Discount applied!', 'success');
          applyCartUpdate(data);
        } else if (matched && matched.applicable === false) {
          showDiscountMsg(describeDiscountFailure(data, previousCart, code), 'error');
        } else {
          showDiscountMsg(
            compatText('discount_invalid_expired', CFG.discountInvalid || 'This code does not exist or has expired.'),
            'error'
          );
        }
      })
      .catch(function (err) {
        showDiscountMsg(explainCartError(err), 'error');
      })
      .finally(function () {
        setSheetUpdating(false);
        btn.classList.remove('is-loading');
        btn.disabled = false;
        input.disabled = false;
      });
  }

  function removeDiscount(code) {
    var target = normalizedDiscountCode(code);
    setSheetUpdating(true, CFG.updating || 'Updating cart…');
    return fetchCartJson('cart.js')
      .then(function (cart) {
        var remaining = cartDiscountCodes(cart).filter(function (candidate) {
          return normalizedDiscountCode(candidate) !== target;
        });
        return fetchCartJson('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: remaining.join(',') }),
        });
      })
      .then(applyCartUpdate)
      .catch(function (err) {
        showDiscountMsg(
          compatText('discount_remove_error', 'The discount code could not be removed. Check your connection, then try again.'),
          'error'
        );
        if (window.MMCompat) window.MMCompat.report(err, 'MMCart.removeDiscount');
        throw err;
      })
      .finally(function () {
        setSheetUpdating(false);
      });
  }

  function needsVariantPicker(item) {
    if (!item) return false;
    if (item.product_has_only_default_variant === true) return false;
    if (item.product_has_only_default_variant === false) return true;
    return !!(item.variant_title && item.variant_title !== 'Default Title');
  }

  function fetchProductVariants(handle) {
    if (!handle) return Promise.resolve(null);
    if (productVariantsCache[handle]) return Promise.resolve(productVariantsCache[handle]);
    return fetch(apiRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        productVariantsCache[handle] = product;
        cacheVariantComparePrices(product);
        return product;
      })
      .catch(function () {
        return null;
      });
  }

  function getVariantPicker(row) {
    return row ? row.querySelector('[data-mm-variant-picker]') : null;
  }

  function dockVariantMenu(picker) {
    if (!picker) return;
    var menu = picker._floatMenu || picker.querySelector('[data-mm-variant-menu]');
    if (!menu) return;
    menu.classList.remove('is-floating', 'is-flip-up');
    menu.hidden = true;
    menu.style.cssText = '';
    if (menu.parentNode !== picker) picker.appendChild(menu);
    delete picker._floatMenu;
  }

  function closeVariantPicker(picker) {
    if (!picker) return;
    picker.classList.remove('is-open');
    dockVariantMenu(picker);
    var trigger = picker.querySelector('[data-mm-variant-toggle]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function positionVariantMenuFloat(menu, trigger) {
    if (!menu || !trigger) return;
    var rect = trigger.getBoundingClientRect();
    var gap = 3;
    var maxH = Math.min(180, Math.round(window.innerHeight * 0.32));
    menu.style.position = 'fixed';
    menu.style.left = Math.max(8, rect.left) + 'px';
    menu.style.width = Math.min(rect.width, window.innerWidth - 16) + 'px';
    menu.style.maxHeight = maxH + 'px';
    menu.style.zIndex = '2147483647';
    menu.style.right = 'auto';

    menu.style.visibility = 'hidden';
    menu.style.display = 'block';
    var menuH = menu.scrollHeight || maxH;
    menu.style.visibility = '';

    var spaceBelow = window.innerHeight - rect.bottom - gap;
    var spaceAbove = rect.top - gap;
    if (spaceBelow < Math.min(menuH, maxH) + 8 && spaceAbove > spaceBelow) {
      menu.classList.add('is-flip-up');
      menu.style.top = 'auto';
      menu.style.bottom = window.innerHeight - rect.top + gap + 'px';
    } else {
      menu.classList.remove('is-flip-up');
      menu.style.bottom = 'auto';
      menu.style.top = rect.bottom + gap + 'px';
    }
  }

  function ensureVariantMenuOptions(picker, callback) {
    var menu = picker.querySelector('[data-mm-variant-menu]');
    if (!menu) {
      callback(false);
      return;
    }
    if (menu.children.length > 0 || picker.getAttribute('data-mm-variants-loaded') === '1') {
      callback(true);
      return;
    }
    var handle = picker.getAttribute('data-product-handle');
    var variantId = parseInt(picker.getAttribute('data-variant-id'), 10);
    fetchProductVariants(handle).then(function (product) {
      if (!product || !product.variants || !product.variants.length) {
        callback(false);
        return;
      }
      menu.innerHTML = buildVariantMenuHtml(product.variants, variantId);
      picker.setAttribute('data-mm-variants-loaded', '1');
      callback(true);
    });
  }

  function openVariantPicker(picker) {
    if (!picker) return;
    var menu = picker.querySelector('[data-mm-variant-menu]');
    var trigger = picker.querySelector('[data-mm-variant-toggle]');
    if (!menu || !trigger) return;

    closeAllVariantMenus(picker);

    ensureVariantMenuOptions(picker, function (ok) {
      if (!ok || !menu.children.length || !root) return;
      picker.classList.add('is-open');
      picker._floatMenu = menu;
      root.appendChild(menu);
      menu.classList.add('is-floating');
      menu.hidden = false;
      menu.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        positionVariantMenuFloat(menu, trigger);
      });
    });
  }

  function closeAllVariantMenus(exceptPicker) {
    if (!root) return;
    root.querySelectorAll('[data-mm-variant-picker].is-open').forEach(function (picker) {
      if (exceptPicker && picker === exceptPicker) return;
      closeVariantPicker(picker);
    });
  }

  function setVariantPickerLabel(picker, title) {
    if (!picker) return;
    var label = picker.querySelector('.mm-cart-sheet__variant-trigger-label');
    if (label) label.textContent = title || '';
  }

  function buildVariantMenuHtml(variants, activeId) {
    var html = '';
    variants.forEach(function (v) {
      var active = v.id === activeId ? ' is-active' : '';
      var disabled = v.available ? '' : ' is-disabled';
      var soldBadge = v.available
        ? ''
        : '<span class="mm-cart-sheet__variant-option-badge">' +
          escapeHtml(CFG.soldOut || 'Sold out') +
          '</span>';
      html +=
        '<button type="button" class="mm-cart-sheet__variant-option' +
        active +
        disabled +
        '" data-mm-variant-option="' +
        v.id +
        '" role="option" aria-selected="' +
        (v.id === activeId ? 'true' : 'false') +
        '"' +
        (v.available ? '' : ' disabled') +
        '>' +
        '<span class="mm-cart-sheet__variant-option-check" aria-hidden="true">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">' +
        '<polyline points="20 6 9 17 4 12"/></svg></span>' +
        '<span class="mm-cart-sheet__variant-option-title">' +
        escapeHtml(v.title || '') +
        '</span>' +
        soldBadge +
        '</button>';
    });
    return html;
  }

  function buildVariantPickerHtml(item) {
    if (isCartGiftItem(item)) return '';
    if (!needsVariantPicker(item)) return '';
    var handle = item.handle || '';
    var label = CFG.chooseFlavour || 'Choose flavour';
    var title =
      item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : label;
    return (
      '<div class="mm-cart-sheet__variant-picker" data-mm-variant-picker ' +
      'data-line-key="' +
      escapeHtml(item.key) +
      '" data-quantity="' +
      item.quantity +
      '" data-variant-id="' +
      item.variant_id +
      '" data-product-handle="' +
      escapeHtml(handle) +
      '">' +
      '<button type="button" class="mm-cart-sheet__variant-trigger" data-mm-variant-toggle ' +
      'aria-expanded="false" aria-haspopup="listbox">' +
      '<span class="mm-cart-sheet__variant-trigger-icon" aria-hidden="true">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
      '<path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/>' +
      '</svg></span>' +
      '<span class="mm-cart-sheet__variant-trigger-text">' +
      '<span class="mm-cart-sheet__variant-trigger-label">' +
      escapeHtml(title) +
      '</span></span>' +
      '<span class="mm-cart-sheet__variant-trigger-chevron" aria-hidden="true">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">' +
      '<path d="M6 9l6 6 6-6"/></svg></span></button>' +
      '<div class="mm-cart-sheet__variant-menu" data-mm-variant-menu hidden role="listbox"></div>' +
      '</div>'
    );
  }

  function findCartItem(key) {
    if (!cartCache || !cartCache.items) return null;
    for (var i = 0; i < cartCache.items.length; i++) {
      if (cartCache.items[i].key === key) return cartCache.items[i];
    }
    return null;
  }

  function cartLineProperties(item) {
    if (!item || !item.properties) return null;
    var props = {};
    Object.keys(item.properties).forEach(function (k) {
      var val = item.properties[k];
      if (val != null && val !== '') props[k] = val;
    });
    return Object.keys(props).length ? props : null;
  }

  function syncVariantPickerState(picker, item) {
    if (!picker || !item) return;
    picker.setAttribute('data-quantity', item.quantity);
    picker.setAttribute('data-line-key', item.key);
    picker.setAttribute('data-variant-id', item.variant_id);
    setVariantPickerLabel(
      picker,
      item.variant_title && item.variant_title !== 'Default Title'
        ? item.variant_title
        : CFG.chooseFlavour || 'Choose flavour'
    );
    var menu = picker.querySelector('[data-mm-variant-menu]');
    if (menu) {
      menu.querySelectorAll('[data-mm-variant-option]').forEach(function (btn) {
        var vid = parseInt(btn.getAttribute('data-mm-variant-option'), 10);
        var isActive = vid === item.variant_id;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }
  }

  function hydrateVariantPickers(cart) {
    if (!cart || !cart.items || !root) return;
    cart.items.forEach(function (item) {
      if (!needsVariantPicker(item)) return;
      var row = getItemRow(item.key);
      if (!row) return;
      var picker = getVariantPicker(row);
      if (!picker) return;

      syncVariantPickerState(picker, item);

      if (picker.getAttribute('data-mm-variants-loaded') === '1') return;

      var handle = item.handle || picker.getAttribute('data-product-handle');
      var menu = picker.querySelector('[data-mm-variant-menu]');
      if (!menu) return;

      fetchProductVariants(handle).then(function (product) {
        if (!product || !product.variants || !product.variants.length) return;
        var activeRow = getItemRow(item.key);
        if (!activeRow) return;
        var activePicker = getVariantPicker(activeRow);
        if (!activePicker || activePicker !== picker) return;

        menu.innerHTML = buildVariantMenuHtml(product.variants, item.variant_id);
        picker.setAttribute('data-mm-variants-loaded', '1');
        syncVariantPickerState(picker, item);
        refreshItemPriceRow(item);
      });
    });
  }

  function swapVariantRequest(item, newVariantId, quantity) {
    var qty = quantity || 1;
    var props = cartLineProperties(item);
    if (props) {
      var addPayload = { id: newVariantId, quantity: qty, properties: props };
      return fetchCartJson('cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [addPayload] }),
      }).then(function () {
        return fetchCartJson('cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        });
      });
    }

    return fetchCartJson('cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 }),
    }).then(function () {
      return fetchCartJson('cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: newVariantId, quantity: qty }] }),
      });
    });
  }

  function changeVariant(oldKey, newVariantId, quantity, optimisticTitle) {
    if (!oldKey || !newVariantId) return;
    var row = getItemRow(oldKey);
    var picker = row && getVariantPicker(row);
    var item = findCartItem(oldKey);
    if (!item && picker) {
      item = {
        key: oldKey,
        variant_id: parseInt(picker.getAttribute('data-variant-id'), 10),
      };
    }
    if (item && parseInt(item.variant_id, 10) === parseInt(newVariantId, 10)) return;

    pendingKeys[oldKey] = true;
    lastUserLineOpAt = Date.now();
    if (row) row.classList.add('mm-cart-sheet__item--updating');
    if (picker) {
      picker.classList.add('is-busy');
      closeVariantPicker(picker);
      if (optimisticTitle) setVariantPickerLabel(picker, optimisticTitle);
    }

    clearLineError(row);
    var doSwap = function () {
      return swapVariantRequest(item, newVariantId, quantity).then(function (data) {
        if (!isCartPayload(data)) throw data;
        return data;
      });
    };

    var swapPromise = runCartMutation(doSwap);

    swapPromise
      .then(function (cart) {
        if (picker) picker.classList.remove('is-busy');
        applyCartUpdate(cart, { loadRecs: false });
      })
      .catch(function (err) {
        var message = explainCartError(err);
        showLineError(row, message);
        showSheetToast(message, 'error');
        if (cartCache) {
          applyCartUpdate(cartCache, { loadRecs: false });
          if (picker && item) syncVariantPickerState(picker, item);
        }
      })
      .finally(function () {
        clearItemBusy(oldKey);
        if (picker) picker.classList.remove('is-busy');
      });
  }

  function buildBranchInventoryHtml(item, part) {
    if (!CFG.branchInventoryEnabled) return '';
    var handle = item.handle || '';
    if (part === 'payload') {
      return '<script type="application/json" class="mm-inv-payload" data-mm-inv-loading="1"></script>';
    }
    return (
      '<div class="mm-inv-root mm-inv--cart-item-detail mm-cart-sheet__item-branch"' +
      ' data-variant-id="' +
      item.variant_id +
      '"' +
      ' data-product-handle="' +
      escapeHtml(handle) +
      '"' +
      ' data-mm-inv-pickup-yes="' +
      escapeHtml(CFG.branchPickupYes || '✓') +
      '"' +
      ' data-mm-inv-pickup-no="' +
      escapeHtml(CFG.branchPickupNo || '✗') +
      '"' +
      ' data-mm-inv-available="' +
      escapeHtml(CFG.branchInvAvailable || 'Available') +
      '"' +
      ' data-mm-inv-unavailable="' +
      escapeHtml(CFG.branchInvUnavailable || 'Unavailable') +
      '"' +
      ' aria-live="polite"><div class="mm-inv-mount"></div></div>'
    );
  }

  function refreshCartBranchInventory(cart) {
    if (!CFG.branchInventoryEnabled || !window.MMBranchInventory) return;
    var sheet = document.getElementById('mmCartSheet');
    if (typeof window.MMBranchInventory.hydrateCartItems === 'function') {
      window.MMBranchInventory.hydrateCartItems(cart, sheet || document);
    } else if (typeof window.MMBranchInventory.updateCartNotice === 'function') {
      window.MMBranchInventory.updateCartNotice(sheet || document);
    }
  }

  function refreshCartVariantExpiry(scope) {
    if (window.MMVariantExpiry && typeof window.MMVariantExpiry.resetAndHydrate === 'function') {
      window.MMVariantExpiry.resetAndHydrate(scope || root || document);
    } else if (window.MMVariantExpiry && typeof window.MMVariantExpiry.hydrate === 'function') {
      window.MMVariantExpiry.hydrate(scope || root || document);
    }
  }

  function buildExpiryHtml(item) {
    var vt = item.variant_title || '';
    if (!vt || vt === 'Default Title') vt = '';
    if (!item.handle) return '';
    var variantIdAttr = item.variant_id ? ' data-variant-id="' + item.variant_id + '"' : '';
    return (
      '<div class="mm-variant-expiry" data-mm-variant-expiry' +
      ' data-product-handle="' +
      escapeHtml(item.handle) +
      '"' +
      variantIdAttr +
      ' data-variant-title="' +
      escapeHtml(vt) +
      '"></div>'
    );
  }

  function isCartGiftItem(item) {
    if (!item) return false;
    var props = item.properties || {};
    return props._gift === 'true';
  }

  function isCartOfferItem(item) {
    if (!item || isCartGiftItem(item)) return false;
    if (window.MMOffers && typeof window.MMOffers.isOfferCartLine === 'function') {
      return window.MMOffers.isOfferCartLine(item);
    }
    var props = item.properties || {};
    if (props._offerType === 'CART_TIER_GIFT' || props.mm_offer_type === 'CART_TIER_GIFT') return false;
    return !!(props._offerId || props._offerType);
  }

  function itemUnitGrams(item, row) {
    var grams = item && parseFloat(item.grams || item.variant_weight || 0);
    if ((grams == null || isNaN(grams)) && row) grams = parseFloat(row.getAttribute('data-item-grams') || '0');
    return !isNaN(grams) && grams >= 0 ? grams : null;
  }

  function weightQtyLimitFor(item, row) {
    if (!CFG.weightQtyLimitsEnabled) return null;
    var grams = itemUnitGrams(item, row);
    if (grams == null) return null;
    var kg = grams / 1000;
    var ranges = Array.isArray(CFG.weightQtyLimitRanges) ? CFG.weightQtyLimitRanges : [];
    for (var i = 0; i < ranges.length; i += 1) {
      var range = ranges[i] || {};
      var fromKg = parseFloat(range.fromKg);
      var toKg = parseFloat(range.toKg);
      var minQty = parseInt(range.minQty, 10);
      var maxQty = parseInt(range.maxQty, 10);
      if (isNaN(fromKg)) fromKg = 0;
      if (isNaN(toKg) || toKg <= 0) continue;
      if (isNaN(minQty) || minQty < 0) minQty = 0;
      if (isNaN(maxQty) || maxQty <= 0) continue;
      if (maxQty < minQty) maxQty = minQty;
      if (kg >= fromKg && kg <= toKg) {
        return { min: minQty, max: maxQty, kg: kg };
      }
    }
    return null;
  }

  function weightQtyMessage(limit, type) {
    if (!limit) return '';
    var template = type === 'max'
      ? (CFG.weightQtyMaxMessage || 'Maximum reached for this product: [max].')
      : (CFG.weightQtyMinMessage || 'Minimum for this product is [min] and maximum is [max].');
    return String(template).replace(/\[min\]/g, limit.min).replace(/\[max\]/g, limit.max);
  }

  function setWeightQtyNotice(row, message) {
    if (!row) return;
    var notice = row.querySelector('[data-mm-weight-qty-notice]');
    if (!notice) return;
    if (message) {
      notice.textContent = message;
      notice.hidden = false;
    } else {
      notice.textContent = '';
      notice.hidden = true;
    }
  }

  function syncWeightQtyLimit(row, item) {
    if (!row || !item) return null;
    var limit = weightQtyLimitFor(item, row);
    var qty = parseInt(item.quantity, 10) || 0;
    var minus = row.querySelector('[data-mm-qty="-1"]');
    var plus = row.querySelector('[data-mm-qty="1"]');
    [minus, plus].forEach(function (btn) {
      if (!btn) return;
      btn.removeAttribute('data-mm-weight-block-message');
      btn.classList.remove('is-weight-limit');
    });
    if (!limit) {
      if (minus) minus.disabled = false;
      if (plus && !isCartGiftItem(item)) plus.disabled = false;
      setWeightQtyNotice(row, '');
      return null;
    }
    if (minus) minus.disabled = false;
    if (plus && !isCartGiftItem(item)) plus.disabled = false;
    if (minus && qty <= limit.min) {
      minus.setAttribute('data-mm-weight-block-message', weightQtyMessage(limit, 'min'));
      minus.classList.add('is-weight-limit');
    }
    if (plus && qty >= limit.max) {
      plus.setAttribute('data-mm-weight-block-message', weightQtyMessage(limit, 'max'));
      plus.classList.add('is-weight-limit');
    }
    if (plus && isCartGiftItem(item)) plus.disabled = true;
    if (qty < limit.min) setWeightQtyNotice(row, weightQtyMessage(limit, 'min'));
    else if (qty >= limit.max) setWeightQtyNotice(row, weightQtyMessage(limit, 'max'));
    else setWeightQtyNotice(row, '');
    return limit;
  }

  function cartHasWeightQtyError(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      var row = getItemRow(item.key);
      var limit = weightQtyLimitFor(item, row);
      var qty = item.quantity || 0;
      return !!(limit && qty > 0 && (qty < limit.min || qty > limit.max));
    });
  }

  function buildQtyHtml(item) {
    var qty = item.quantity || 1;
    var isGift = isCartGiftItem(item);
    var giftCls = isGift ? ' mm-cart-sheet__qty--gift' : '';
    var plusDisabled = isGift ? ' disabled aria-disabled="true"' : '';
    return (
      '<div class="mm-cart-sheet__qty' + giftCls + '">' +
      '<button type="button" data-mm-qty="-1" aria-label="-">−</button>' +
      '<span class="mm-cart-sheet__qty-val">' +
      qty +
      '</span>' +
      '<button type="button" data-mm-qty="1" aria-label="+"' +
      plusDisabled +
      '>+</button>' +
      '</div>'
    );
  }

  function buildItemHtml(item) {
    var img = item.image || '';
    var itemUrl = item.url || '/products/' + (item.handle || '');
    if (itemUrl.indexOf('http') !== 0 && localePrefix()) {
      itemUrl = localePrefix() + itemUrl;
    }

    var pricing = getItemPricing(item);
    var compareAttr =
      pricing.hasSale && pricing.compareAtUnit
        ? ' data-compare-at-unit="' + pricing.compareAtUnit + '"'
        : '';
    var handleAttr = item.handle ? ' data-product-handle="' + escapeHtml(item.handle) + '"' : '';
    var offerAttr = isCartOfferItem(item) ? ' data-offer-line="1"' : '';

    var html =
      '<div class="mm-cart-sheet__item" data-cart-key="' +
      escapeHtml(item.key) +
      '" data-variant-id="' +
      item.variant_id +
      '" data-item-grams="' +
      (item.grams || 0) +
      '"' +
      handleAttr +
      offerAttr +
      compareAttr +
      ' data-variant-price="' +
      (item.final_price || item.price || 0) +
      '">';
    html += buildBranchInventoryHtml(item, 'payload');
    html +=
      '<a href="' +
      escapeHtml(itemUrl) +
      '" class="mm-cart-sheet__item-img-wrap">';
    if (img) {
      html +=
        '<img class="mm-cart-sheet__item-img" src="' +
        escapeHtml(img) +
        '" alt="" width="64" height="64" loading="lazy">';
    }
    html +=
      '</a><div class="mm-cart-sheet__item-info">' +
      '<a href="' +
      escapeHtml(itemUrl) +
      '" class="mm-cart-sheet__item-title">' +
      escapeHtml(item.product_title) +
      '</a>';
    html += buildBranchInventoryHtml(item, 'surface');
    html += buildVariantPickerHtml(item);
    html += buildExpiryHtml(item);
    html +=
      '<div class="mm-cart-sheet__item-row">' +
      buildItemPriceHtml(item, null) +
      '<div class="mm-cart-sheet__item-actions">' +
      buildQtyHtml(item) +
      '<button type="button" class="mm-cart-sheet__remove" data-mm-remove aria-label="' +
      escapeHtml(CFG.removeItem || 'Remove') +
      '">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
      '<path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>' +
      '</svg></button></div></div><p class="mm-cart-sheet__qty-limit" data-mm-weight-qty-notice hidden></p></div></div>';
    return html;
  }

  function syncItemsList(cart) {
    var container = $('#mmCartSheetItems');
    var body = $('#mmCartSheetBody');
    var footer = $('#mmCartSheetFooter');
    var incentives = $('#mmCartSheetIncentives');

    if (!cart.items || !cart.items.length) {
      if (body) {
        body.innerHTML =
          '<div class="mm-cart-sheet__empty" id="mmCartSheetEmpty"><p>' +
          escapeHtml(CFG.emptyText || 'Your cart is empty') +
          '</p><a href="' + escapeHtml(window.MMShop ? window.MMShop.root() + 'collections/all' : '/collections/all') +
          '" class="mm-cart-sheet__empty-btn" data-mm-cart-close>' +
          escapeHtml(CFG.startShopping || 'Start shopping') + '</a></div>';
      }
      if (footer) footer.hidden = true;
      if (incentives) incentives.hidden = true;
      var recs = $('#mmCartSheetRecs');
      if (recs) recs.hidden = true;
      lastRecsKey = '';
      syncClearAllBtn(0);
      refreshCartBranchInventory(cart);
      refreshCartVariantExpiry(root);
      return;
    }

    if (footer) footer.hidden = false;
    if (incentives) incentives.hidden = false;
    syncClearAllBtn(cart.item_count || cart.items.length);

    if (!container) {
      if (body) {
        body.innerHTML = '<div class="mm-cart-sheet__items" id="mmCartSheetItems"></div>';
        container = $('#mmCartSheetItems');
      }
    }

    if (!container) return;

    var existingKeys = {};
    container.querySelectorAll('.mm-cart-sheet__item[data-cart-key]').forEach(function (el) {
      existingKeys[el.getAttribute('data-cart-key')] = el;
    });

    var cartKeys = {};
    cart.items.forEach(function (item) {
      cartKeys[item.key] = true;
      var el = existingKeys[item.key];
      if (el) {
        el.setAttribute('data-variant-id', item.variant_id);
        el.setAttribute('data-item-grams', item.grams || 0);
        if (item.handle) el.setAttribute('data-product-handle', item.handle);
        var prices = el.querySelector('.mm-cart-sheet__item-prices');
        var qtyVal = el.querySelector('.mm-cart-sheet__qty-val');
        if (prices) {
          var newPricing = getItemPricing(item, el);
          var hasExistingSale = prices.querySelector(
            '.mm-cart-sheet__price-saved, .mm-cart-sheet__price-compare'
          );
          if (!newPricing.hasSale && hasExistingSale) {
            /* Keep Liquid sale display until product.js enrich fills compare_at */
          } else {
            prices.outerHTML = buildItemPriceHtml(item, el);
            if (newPricing.hasSale && newPricing.compareAtUnit) {
              el.setAttribute('data-compare-at-unit', newPricing.compareAtUnit);
            }
          }
        }
        if (qtyVal) qtyVal.textContent = item.quantity;
        var imgEl = el.querySelector('.mm-cart-sheet__item-img');
        if (imgEl && item.image) imgEl.src = item.image;
        var picker = getVariantPicker(el);
        if (picker) {
          if (String(picker.getAttribute('data-variant-id')) !== String(item.variant_id)) {
            picker.removeAttribute('data-mm-variants-loaded');
          }
          syncVariantPickerState(picker, item);
        }
        var expiryEl = el.querySelector('[data-mm-variant-expiry]');
        if (!expiryEl) {
          var infoEl = el.querySelector('.mm-cart-sheet__item-info');
          var rowEl = el.querySelector('.mm-cart-sheet__item-row');
          if (infoEl) {
            var expiryWrap = document.createElement('div');
            expiryWrap.innerHTML = buildExpiryHtml(item);
            var expiryNode = expiryWrap.firstElementChild;
            if (expiryNode) {
              if (rowEl) infoEl.insertBefore(expiryNode, rowEl);
              else infoEl.appendChild(expiryNode);
            }
          }
        } else {
          var expiryTitle =
            item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          expiryEl.setAttribute('data-variant-title', expiryTitle);
          if (item.variant_id) expiryEl.setAttribute('data-variant-id', item.variant_id);
          if (item.handle) expiryEl.setAttribute('data-product-handle', item.handle);
        }
        el.classList.remove('mm-cart-sheet__item--removing', 'mm-cart-sheet__item--updating');
        if (isCartOfferItem(item)) el.setAttribute('data-offer-line', '1');
        else el.removeAttribute('data-offer-line');
        syncWeightQtyLimit(el, item);
      } else {
        var div = document.createElement('div');
        div.innerHTML = buildItemHtml(item);
        var node = div.firstElementChild;
        node.classList.add('mm-cart-sheet__item--enter');
        syncWeightQtyLimit(node, item);
        container.appendChild(node);
        requestAnimationFrame(function () {
          node.classList.remove('mm-cart-sheet__item--enter');
        });
      }
    });

    Object.keys(existingKeys).forEach(function (key) {
      if (!cartKeys[key]) {
        var el = existingKeys[key];
        el.classList.add('mm-cart-sheet__item--removing');
        setTimeout(function () {
          if (el.parentNode) el.remove();
        }, 320);
      }
    });

    hydrateVariantPickers(cart);
    refreshCartBranchInventory(cart);
    refreshCartVariantExpiry(root);
  }

  function setSheetUpdating(on, message) {
    if (on) sheetUpdatingCount++;
    else sheetUpdatingCount = Math.max(0, sheetUpdatingCount - 1);
    var active = sheetUpdatingCount > 0;
    var el = $('#mmCartSheetUpdating');
    var panel = root && root.querySelector('.mm-cart-sheet__panel');
    var msgEl = $('#mmCartSheetUpdatingMsg');
    if (msgEl && message) msgEl.textContent = message;
    else if (msgEl && !active) msgEl.textContent = CFG.updating || 'Updating cart…';
    if (el) {
      el.hidden = !active;
      el.setAttribute('aria-busy', active ? 'true' : 'false');
    }
    if (panel) panel.classList.toggle('is-updating', active);
    if (root) root.classList.toggle('mm-cart-sheet--busy', active);
  }

  function updateFooterTotals(cart) {
    if (!cart) return;
    var subEl = $('#mmCartSheetSubtotal');
    if (!subEl) return;
    subEl.innerHTML = formatMoney(cart.total_price || 0);
  }

  function maybeLoadRecs(cart, force) {
    if (!featureVisible('recommendationsCountries')) {
      var wrap = $('#mmCartSheetRecs');
      if (wrap) wrap.hidden = true;
      return;
    }
    var productIds = (cart.items || []).map(function (i) {
      return i.product_id;
    });
    var key = productIds.join(',');
    if (!force && key === lastRecsKey) return;
    lastRecsKey = key;

    fetchRecommendations(productIds, 6).then(function (recs) {
      renderRecs(recs, productIds);
    });
  }

  function refreshTierGifts(cart, allowPopup) {
    /* Default: never auto-open gift popup from sheet refreshes (unlock path handles once) */
    if (!featureVisible('giftCountries')) {
      hideTierGiftUi();
      return;
    }
    if (!window.MMCartTierGifts || !cart || !cart.items) return;
    if (typeof window.MMCartTierGifts.refresh === 'function') {
      window.MMCartTierGifts.refresh(cart, { uiOnly: true, allowPopup: allowPopup === true });
      return;
    }
    if (typeof window.MMCartTierGifts.updateUI === 'function') {
      window.MMCartTierGifts.updateUI(cart);
    }
  }

  function applyCartUpdate(cart, opts) {
    opts = opts || {};
    if (!isCartPayload(cart)) return;

    if (cart.items) {
      var liveItems = cart.items.filter(function (it) { return (it.quantity || 0) > 0; });
      if (liveItems.length !== cart.items.length) {
        cart = Object.assign({}, cart, {
          items: liveItems,
          item_count: liveItems.reduce(function (s, it) { return s + (it.quantity || 0); }, 0)
        });
      }
    }

    var token = ++cartUpdateToken;
    cartCache = cart;

    updateBadges(cart.item_count, false);
    updateFooterTotals(cart);
    renderIncentives(cart);
    refreshTierGifts(cart, false);
    renderDiscounts(cart);
    syncItemsList(cart);
    renderDiscountEligibility(cart);
    if (window.MMCartOffers && typeof window.MMCartOffers.refresh === 'function') {
      window.MMCartOffers.refresh(cart);
    } else {
      requestAnimationFrame(function () {
        if (window.MMCartOffers && typeof window.MMCartOffers.refresh === 'function') {
          window.MMCartOffers.refresh(cart);
        }
      });
    }
    if (token === cartUpdateToken) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, mmUiOnly: true } }));
    }

    var enrichPromise = enrichCartItemPrices(cart);
    if (opts.loadRecs !== false && cart.items && cart.items.length) {
      enrichPromise.then(function () {
        maybeLoadRecs(cart, opts.forceRecs);
      });
    }
  }

  function fetchRecommendations(productIds, limit) {
    if (window.MMRecommendations && typeof window.MMRecommendations.fetch === 'function') {
      return window.MMRecommendations.fetch(productIds, limit || 6);
    }
    return Promise.resolve([]);
  }

  function renderRecs(products, cartProductIds) {
    var wrap = $('#mmCartSheetRecs');
    var scroll = $('#mmCartSheetRecsScroll');
    if (!wrap || !scroll) return;

    var inCart = {};
    (cartProductIds || []).forEach(function (id) {
      inCart[id] = true;
    });

    var filtered = products.filter(function (p) {
      if (inCart[p.id]) return false;
      if (window.MMRecommendations && typeof window.MMRecommendations.isProductPurchasable === 'function') {
        return window.MMRecommendations.isProductPurchasable(p);
      }
      return p && p.available !== false;
    });

    if (!filtered.length) {
      wrap.hidden = true;
      return;
    }

    wrap.hidden = false;
    var addLabel = CFG.recAdd || '+ Add';
    var html = '';

    filtered.forEach(function (p) {
      var pricing =
        window.MMRecommendations && typeof window.MMRecommendations.getDisplayPricing === 'function'
          ? window.MMRecommendations.getDisplayPricing(p)
          : null;
      var v = pricing ? pricing.variant : p.variants && p.variants[0];
      if (!v) return;
      var img =
        window.MMProductImage && typeof window.MMProductImage.url === 'function'
          ? window.MMProductImage.url(p, 200)
          : '';
      if (!img && p.featured_image) {
        img = p.featured_image;
        if (typeof img === 'object' && img.src) img = img.src;
      }
      var url = productPageUrl(p);
      var priceHtml = '';
      if (pricing && pricing.onSale) {
        priceHtml =
          '<span class="mm-cart-sheet__rec-price-sale">' +
          formatMoney(pricing.price) +
          '</span>' +
          '<span class="mm-cart-sheet__rec-price-compare">' +
          formatMoney(pricing.compareAt) +
          '</span>';
      } else {
        priceHtml =
          '<span class="mm-cart-sheet__rec-price-sale">' +
          formatMoney(pricing ? pricing.price : v.price) +
          '</span>';
      }
      var badgeHtml =
        pricing && pricing.onSale
          ? '<span class="mm-cart-sheet__rec-badge">-' + pricing.discountPct + '%</span>'
          : '';

      html +=
        '<div class="mm-cart-sheet__rec-card">' +
        '<a href="' +
        escapeHtml(url) +
        '" class="mm-cart-sheet__rec-img-wrap">' +
        badgeHtml +
        '<img class="mm-cart-sheet__rec-img" src="' +
        escapeHtml(img) +
        '" alt="' +
        escapeHtml(p.title) +
        '" loading="lazy" width="108" height="108"></a>' +
        '<div class="mm-cart-sheet__rec-body">' +
        '<a href="' +
        escapeHtml(url) +
        '" class="mm-cart-sheet__rec-name">' +
        escapeHtml(p.title) +
        '</a>' +
        '<div class="mm-cart-sheet__rec-price">' +
        priceHtml +
        '</div>' +
        '<button type="button" class="mm-cart-sheet__rec-add" data-variant-id="' +
        v.id +
        '">' +
        escapeHtml(addLabel) +
        '</button>' +
        '</div></div>';
    });

    scroll.innerHTML = html;

    scroll.querySelectorAll('.mm-cart-sheet__rec-add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!vid || btn.disabled) return;

        var card = btn.closest('.mm-cart-sheet__rec-card');
        var img = card && card.querySelector('.mm-cart-sheet__rec-img');
        var addedLabel = CFG.recAdded || '✓';

        btn.disabled = true;
        btn.classList.add('is-busy');
        if (card) card.classList.add('is-adding');

        var prevCount = cartCache ? cartCache.item_count : 0;
        updateBadges(prevCount + 1, true);

        add(vid, 1, {
          openSheet: false,
          quickAdd: true,
          sourceElement: btn,
          imageUrl: img ? img.src : null,
        })
          .then(function () {
            btn.classList.remove('is-busy');
            btn.classList.add('is-added');
            btn.textContent = addedLabel;
            if (card) {
              card.classList.remove('is-adding');
              card.classList.add('is-added-flash');
            }
            setTimeout(function () {
              btn.disabled = false;
              btn.classList.remove('is-added');
              if (card) card.classList.remove('is-added-flash');
              btn.textContent = addLabel;
            }, 650);
          })
          .catch(function () {
            btn.disabled = false;
            btn.classList.remove('is-busy', 'is-added');
            if (card) card.classList.remove('is-adding', 'is-added-flash');
            btn.textContent = addLabel;
            if (cartCache) updateBadges(cartCache.item_count, false);
          });
      });
    });
  }

  function renderCart(cart, opts) {
    opts = opts || {};
    if (opts.full) {
      var body = $('#mmCartSheetBody');
      if (body && cart.items && cart.items.length) {
        var html = '';
        cart.items.forEach(function (item) {
          html += buildItemHtml(item);
        });
        body.innerHTML = '<div class="mm-cart-sheet__items" id="mmCartSheetItems">' + html + '</div>';
      }
    }
    applyCartUpdate(cart, { forceRecs: true, loadRecs: true });
  }

  function ensureLineError(row) {
    if (!row) return null;
    var error = row.querySelector('[data-mm-line-error]');
    if (error) return error;
    error = document.createElement('p');
    error.className = 'mm-cart-sheet__line-error';
    error.setAttribute('data-mm-line-error', '');
    error.setAttribute('role', 'alert');
    error.setAttribute('aria-live', 'assertive');
    error.hidden = true;
    var info = row.querySelector('.mm-cart-sheet__item-info');
    if (info) info.appendChild(error);
    return error;
  }

  function showLineError(row, message) {
    var error = ensureLineError(row);
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function clearLineError(row) {
    var error = row && row.querySelector('[data-mm-line-error]');
    if (!error) return;
    error.textContent = '';
    error.hidden = true;
  }

  function flushQtyChange(key, next) {
    var row = getItemRow(key);
    clearLineError(row);
    pendingKeys[key] = true;
    lastUserLineOpAt = Date.now();

    if (row) {
      row.classList.add('mm-cart-sheet__item--updating');
      var qtyWrap = row.querySelector('.mm-cart-sheet__qty');
      if (qtyWrap) qtyWrap.classList.add('mm-cart-sheet__qty--busy');
      if (next === 0) row.classList.add('mm-cart-sheet__item--removing');
    }

    qtySafetyTimers[key] = setTimeout(function () {
      clearItemBusy(key);
      forceSheetUpdatingOff();
      fetchCartJson('cart.js')
        .then(function (fresh) { applyCartUpdate(fresh, { loadRecs: false }); })
        .catch(function () {
          if (cartCache) applyCartUpdate(cartCache, { loadRecs: false });
        });
    }, 12000);

    setSheetUpdating(true, CFG.updating || 'Updating cart…');

    function doChange() {
      return fetchCartJson('cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: next }),
      });
    }

    var changePromise = runCartMutation(doChange);

    return changePromise
      .then(function (cart) {
        applyCartUpdate(cart, { loadRecs: next === 0 });
        if (next === 0) {
          showSheetToast(CFG.itemRemoved);
        }
      })
      .catch(function (err) {
        var message = explainCartError(err);
        showLineError(row, message);
        showSheetToast(message, 'error');
        forceSheetUpdatingOff();
        return fetchCartJson('cart.js')
          .then(function (fresh) { applyCartUpdate(fresh, { loadRecs: false }); })
          .catch(function () {
            if (cartCache) applyCartUpdate(cartCache, { loadRecs: false });
          });
      })
      .finally(function () {
        clearItemBusy(key);
        setSheetUpdating(false);
      });
  }

  function changeQtyByKey(key, delta, setQty) {
    if (!key) return;

    var row = getItemRow(key);
    var qtyEl = row && row.querySelector('.mm-cart-sheet__qty-val');
    var cur = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (isNaN(cur)) cur = 1;
    var next = setQty ? Math.max(0, delta) : Math.max(0, cur + delta);
    var lineItem = cartCache && cartCache.items
      ? cartCache.items.find(function (it) { return it.key === key; })
      : null;
    var weightLimit = weightQtyLimitFor(lineItem, row);

    if (weightLimit && next > 0 && next < weightLimit.min) {
      if (next > cur) {
        next = weightLimit.min;
      } else {
        var minMsg = weightQtyMessage(weightLimit, 'min');
        setWeightQtyNotice(row, minMsg);
        showSheetToast(minMsg, 'error');
        return;
      }
    }
    if (weightLimit && next > weightLimit.max && next > cur) {
      var maxMsg = weightQtyMessage(weightLimit, 'max');
      setWeightQtyNotice(row, maxMsg);
      showSheetToast(maxMsg, 'error');
      return;
    }

    if (next === cur) return;

    if (cartCache && cartCache.items) {
      if (
        lineItem &&
        delta > 0 &&
        isCartOfferItem(lineItem) &&
        window.MMOffers
      ) {
        var rowBusy = row || getItemRow(key);
        if (rowBusy) rowBusy.classList.add('mm-cart-sheet__item--updating');
        setSheetUpdating(true, CFG.updating || 'Updating cart…');
        var bumpOffer =
          typeof window.MMOffers.increaseOfferLineQty === 'function'
            ? window.MMOffers.increaseOfferLineQty(lineItem, delta, { apply: false })
            : typeof window.MMOffers.increasePlainVariantQty === 'function'
              ? window.MMOffers.increasePlainVariantQty(lineItem.variant_id, delta, { apply: false })
              : null;
        if (bumpOffer) {
          clearLineError(rowBusy);
          bumpOffer
            .then(function (cart) {
              applyCartUpdate(cart, { loadRecs: false });
            })
            .catch(function (err) {
              var message = explainCartError(err);
              showLineError(rowBusy, message);
              showSheetToast(message, 'error');
              forceSheetUpdatingOff();
              fetchCartJson('cart.js')
                .then(function (fresh) { applyCartUpdate(fresh, { loadRecs: false }); })
                .catch(function () {
                  if (cartCache) applyCartUpdate(cartCache, { loadRecs: false });
                });
            })
            .finally(function () {
              clearItemBusy(key);
              setSheetUpdating(false);
            });
          return;
        }
      }
      if (
        lineItem &&
        isCartGiftItem(lineItem) &&
        next > cur &&
        window.MMCartTotals &&
        typeof window.MMCartTotals.canIncreaseGiftQty === 'function' &&
        !window.MMCartTotals.canIncreaseGiftQty(lineItem, next)
      ) {
        showSheetToast(
          CFG.giftQtyBlocked ||
            ((document.documentElement.lang || '').indexOf('ar') === 0
              ? 'الهدية مجانية — كمية واحدة فقط'
              : 'Free gift — quantity is limited to 1')
        );
        return;
      }
    }

    if (cartCache && cartCache.items) {
      var estCount = 0;
      var nextItems = [];
      cartCache.items.forEach(function (it) {
        var q = it.key === key ? next : it.quantity;
        if (q > 0) {
          estCount += q;
          if (it.key === key) {
            var oldQ = it.quantity || 1;
            var line = it.final_line_price != null ? it.final_line_price : (it.price || 0) * oldQ;
            var unit = oldQ > 0 ? line / oldQ : (it.price || 0);
            nextItems.push(Object.assign({}, it, { quantity: q, final_line_price: Math.round(unit * q) }));
          } else {
            nextItems.push(it);
          }
        }
      });
      var estTotal = nextItems.reduce(function (s, it) {
        if (isCartGiftItem(it)) return s;
        return s + (it.final_line_price != null ? it.final_line_price : (it.price || 0) * (it.quantity || 1));
      }, 0);
      cartCache = Object.assign({}, cartCache, { items: nextItems, item_count: estCount, total_price: estTotal });
      updateBadges(estCount, next > cur);
      updateFooterTotals(cartCache);
      renderIncentives(cartCache);
      refreshTierGifts(cartCache, false);
    } else {
      var badgeEl = document.querySelector('.mm-cart-badge, [data-cart-count]');
      var badgeN = badgeEl ? parseInt(badgeEl.textContent, 10) : 0;
      if (!isNaN(badgeN)) updateBadges(Math.max(0, badgeN + (next - cur)), next > cur);
    }

    if (qtyEl) {
      qtyEl.textContent = next;
      if (lineItem && row) syncWeightQtyLimit(row, Object.assign({}, lineItem, { quantity: next }));
      if (row) {
        row.classList.add('mm-cart-sheet__item--pulse');
        setTimeout(function () {
          if (row) row.classList.remove('mm-cart-sheet__item--pulse');
        }, 280);
      }
    }

    function scheduleFlush() {
      clearTimeout(qtyTimers[key]);
      qtyTimers[key] = setTimeout(function () {
        if (pendingKeys[key]) {
          scheduleFlush();
          return;
        }
        flushQtyChange(key, next);
      }, 280);
    }
    scheduleFlush();
  }

  function showSheetToast(msg, type) {
    if (!msg) return;
    var banner = $('#mmCartSheetSuccess');
    var text = $('#mmCartSheetSuccessText');
    if (!banner || !text) return;
    // Callers across the theme pass either 'error' or a boolean. Accepting both
    // keeps a failure from being painted in the green "Added to cart" banner.
    var isError = type === 'error' || type === true || type === 'danger';
    text.textContent = msg;
    banner.classList.toggle('mm-cart-sheet__success--error', isError);
    banner.classList.add('is-visible');
    clearTimeout(banner._hideTimer);
    banner._hideTimer = setTimeout(function () {
      banner.classList.remove('is-visible');
      banner.classList.remove('mm-cart-sheet__success--error');
    }, 2200);
  }

  function bindCartActions() {
    if (!root || actionsBound) return;
    actionsBound = true;

    root.addEventListener(
      'click',
      function (e) {
        var checkoutBtn = e.target.closest('.mm-cart-sheet__btn--checkout');
        if (checkoutBtn && cartHasWeightQtyError(cartCache)) {
          e.preventDefault();
          showSheetToast(CFG.weightQtyCheckoutMessage || 'Some products need quantity changes before checkout.', 'error');
          return;
        }

        var qtyBtn = e.target.closest('[data-mm-qty]');
        if (qtyBtn) {
          e.preventDefault();
          e.stopPropagation();
          var blockMsg = qtyBtn.getAttribute('data-mm-weight-block-message');
          if (blockMsg) {
            var blockRow = qtyBtn.closest('.mm-cart-sheet__item');
            setWeightQtyNotice(blockRow, blockMsg);
            showSheetToast(blockMsg, 'error');
            return;
          }
          if (qtyBtn.disabled || qtyBtn.getAttribute('aria-disabled') === 'true') return;
          var row = qtyBtn.closest('.mm-cart-sheet__item');
          var key = row && row.getAttribute('data-cart-key');
          var delta = parseInt(qtyBtn.getAttribute('data-mm-qty'), 10);
          if (key && !isNaN(delta)) changeQtyByKey(key, delta);
          return;
        }

        var removeBtn = e.target.closest('[data-mm-remove]');
        if (removeBtn) {
          e.preventDefault();
          e.stopPropagation();
          var removeRow = removeBtn.closest('.mm-cart-sheet__item');
          var rKey = removeRow && removeRow.getAttribute('data-cart-key');
          if (rKey) {
            clearTimeout(qtyTimers[rKey]);
            flushQtyChange(rKey, 0);
          }
          return;
        }

        if (e.target.closest('[data-mm-apply-discount]')) {
          e.preventDefault();
          applyDiscount();
          return;
        }

        var rmDisc = e.target.closest('[data-mm-remove-discount]');
        if (rmDisc) {
          e.preventDefault();
          removeDiscount(rmDisc.getAttribute('data-mm-remove-discount'));
        }

        var variantToggle = e.target.closest('[data-mm-variant-toggle]');
        if (variantToggle) {
          e.preventDefault();
          e.stopPropagation();
          var pickerEl = variantToggle.closest('[data-mm-variant-picker]');
          if (!pickerEl || pickerEl.classList.contains('is-busy')) return;
          if (pickerEl.classList.contains('is-open')) {
            closeVariantPicker(pickerEl);
          } else {
            openVariantPicker(pickerEl);
          }
          return;
        }

        var variantOpt = e.target.closest('[data-mm-variant-option]');
        if (variantOpt && !variantOpt.disabled) {
          e.preventDefault();
          e.stopPropagation();
          var pickerWrap =
            variantOpt.closest('[data-mm-variant-picker]') ||
            (function () {
              var floatMenu = variantOpt.closest('[data-mm-variant-menu].is-floating');
              if (!floatMenu || !root) return null;
              var openPickers = root.querySelectorAll('[data-mm-variant-picker].is-open');
              for (var i = 0; i < openPickers.length; i++) {
                if (openPickers[i]._floatMenu === floatMenu) return openPickers[i];
              }
              return null;
            })();
          if (!pickerWrap || pickerWrap.classList.contains('is-busy')) return;
          closeVariantPicker(pickerWrap);
          var lineKey = pickerWrap.getAttribute('data-line-key');
          var newVariant = parseInt(variantOpt.getAttribute('data-mm-variant-option'), 10);
          var oldVariant = parseInt(pickerWrap.getAttribute('data-variant-id'), 10);
          var lineQty = parseInt(pickerWrap.getAttribute('data-quantity'), 10) || 1;
          var optTitleEl = variantOpt.querySelector('.mm-cart-sheet__variant-option-title');
          var optTitle = optTitleEl ? optTitleEl.textContent.trim() : '';
          if (lineKey && newVariant && newVariant !== oldVariant) {
            changeVariant(lineKey, newVariant, lineQty, optTitle);
          }
          return;
        }

        if (
          !e.target.closest('[data-mm-variant-picker]') &&
          !e.target.closest('[data-mm-variant-menu].is-floating')
        ) {
          closeAllVariantMenus();
        }
      },
      { passive: false }
    );

    var scrollEl = $('#mmCartSheetScroll');
    if (scrollEl && !scrollEl._mmVariantScrollBound) {
      scrollEl._mmVariantScrollBound = true;
      scrollEl.addEventListener(
        'scroll',
        function () {
          closeAllVariantMenus();
        },
        { passive: true }
      );
    }

    var discInput = $('#mmCartSheetDiscountInput');
    if (discInput) {
      discInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          applyDiscount();
        }
      });
    }
  }

  function showSuccessBanner(title) {
    var banner = $('#mmCartSheetSuccess');
    var text = $('#mmCartSheetSuccessText');
    if (!banner) return;
    if (text) {
      text.textContent = (CFG.addedText || 'Added to cart') + (title ? ': ' + title : '');
    }
    banner.classList.add('is-visible');
    clearTimeout(banner._hideTimer);
    banner._hideTimer = setTimeout(function () {
      banner.classList.remove('is-visible');
    }, 3200);
  }

  function setOverlayState(opening) {
    document.body.classList.toggle('mm-cart-sheet-open', opening);
  }

  function open(opts) {
    opts = opts || {};
    if (!root) return;
    if (!isOpen) previousFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setOverlayState(true);
    isOpen = true;
    try {
      if (window.MMWheelLauncher && typeof window.MMWheelLauncher.refresh === 'function') {
        window.MMWheelLauncher.refresh();
      }
    } catch (e) {}
    window.requestAnimationFrame(function () {
      var closeBtn = root.querySelector('[data-mm-cart-close]:not(.mm-cart-sheet__overlay)');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    });
    updateSdd();
    if (opts.cart && isCartPayload(opts.cart)) {
      applyCartUpdate(opts.cart, { forceRecs: true, loadRecs: true });
    } else if (!opts.skipRefresh) {
      refresh();
    } else {
      refreshCartVariantExpiry(root);
    }
  }

  function close() {
    if (!root) return;
    closeAllVariantMenus();
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setOverlayState(false);
    isOpen = false;
    if (window.MMWheelLauncher && typeof window.MMWheelLauncher.close === 'function') {
      window.MMWheelLauncher.close();
    }
    if (previousFocus && document.contains(previousFocus) && typeof previousFocus.focus === 'function') {
      window.setTimeout(function () {
        previousFocus.focus({ preventScroll: true });
        previousFocus = null;
      }, 240);
    } else {
      previousFocus = null;
    }
  }

  function refresh() {
    return fetchCart().then(function (cart) {
      applyCartUpdate(cart, { forceRecs: !lastRecsKey });
      return cart;
    });
  }

  function addToCartRequest(variantId, quantity, options) {
    options = options || {};
    var qty = quantity || 1;
    var openSheet = options.openSheet !== false;
    var quickAdd = options.quickAdd === true;
    var sourceEl = options.sourceElement;
    var imageUrl = options.imageUrl;

    skipGlobalHook = true;
    var payload = { id: variantId, quantity: qty };
    if (window.MMBogo && typeof window.MMBogo.buildItems === 'function') {
      var bogoItems = window.MMBogo.buildItems(variantId, qty);
      if (bogoItems.length > 1) {
        payload = { items: bogoItems };
      }
    }
    return fetchCartJson('cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (item) {
        lastAddedTitle = item.product_title || item.title || '';
        if (imageUrl || item.image) flyToCart(sourceEl, imageUrl || item.image);
        return fetchCart();
      })
      .then(function (cart) {
        updateBadges(cart.item_count, !quickAdd);
        if (!quickAdd) lastRecsKey = '';
        var updateOpts = { forceRecs: !quickAdd, loadRecs: !quickAdd };
        applyCartUpdate(cart, updateOpts);
        if (openSheet) {
          showSuccessBanner(lastAddedTitle);
          if (!isOpen) open({ skipRefresh: true, cart: cart });
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        return cart;
      })
      .finally(function () {
        skipGlobalHook = false;
      });
  }

  function withTimeout(promise, ms) {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        reject(new Error('timeout'));
      }, ms);
      promise.then(
        function (value) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          resolve(value);
        },
        function (err) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          reject(err);
        }
      );
    });
  }

  function setAtcBusy(el, on) {
    if (!el || !el.classList) return;
    if (on) {
      el.classList.add('mm-atc-busy');
      el.setAttribute('aria-busy', 'true');
      try {
        if (window.getComputedStyle(el).position === 'static') {
          el.style.position = 'relative';
          el.setAttribute('data-mm-atc-pos', '1');
        }
      } catch (e) {}
    } else {
      el.classList.remove('mm-atc-busy');
      el.setAttribute('aria-busy', 'false');
      if (el.getAttribute('data-mm-atc-pos') === '1') {
        el.style.position = '';
        el.removeAttribute('data-mm-atc-pos');
      }
    }
  }

  /**
   * Ask the storefront whether a variant is really buyable right now.
   * Returns true / false, or null when the check itself could not be trusted.
   */
  function liveVariantAvailable(variantId) {
    var id = parseInt(variantId, 10);
    if (!id) return Promise.resolve(null);
    return fetch(cartApi('variants/' + id + '.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (v) {
        return v && typeof v.available === 'boolean' ? v.available : null;
      })
      .catch(function () {
        return null;
      });
  }

  var cartSessionRebuilt = false;

  function dropCartCookie() {
    var expiry = 'Thu, 01 Jan 1970 00:00:00 GMT';
    ['cart', 'cart_sig', 'cart_ts', 'cart_ver'].forEach(function (name) {
      try {
        document.cookie = name + '=; expires=' + expiry + '; path=/';
        document.cookie = name + '=; expires=' + expiry + '; path=/; domain=' + location.hostname;
      } catch (e) {}
    });
  }

  /**
   * Start a clean cart and carry the customer's lines across.
   *
   * A cart can end up bound to a destination the store cannot fulfil (for
   * example after a shipping-rate estimate for an off-market country). Shopify
   * then rejects EVERY add on that cart token with "already sold out", for
   * in-stock products, and keeps doing so until the token is replaced — the
   * customer cannot buy anything for the rest of the session. Replacing the
   * token is the only recovery, so we do it once per page load and restore the
   * lines, note and attributes onto the new cart.
   */
  function rebuildCartSession() {
    if (cartSessionRebuilt) return Promise.resolve(false);
    cartSessionRebuilt = true;

    return fetchCartJson('cart.js')
      .catch(function () {
        return null;
      })
      .then(function (old) {
        var items = ((old && old.items) || []).map(function (item) {
          var line = { id: item.variant_id, quantity: item.quantity };
          if (item.properties && Object.keys(item.properties).length) {
            line.properties = item.properties;
          }
          if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
            line.selling_plan = item.selling_plan_allocation.selling_plan.id;
          }
          return line;
        });

        dropCartCookie();

        var restore = items.length
          ? fetchCartJson('cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            }).catch(function () {
              return null; // a line that truly cannot be re-added must not block recovery
            })
          : Promise.resolve(null);

        return restore.then(function () {
          var carry = {};
          if (old && old.note) carry.note = old.note;
          if (old && old.attributes && Object.keys(old.attributes).length) carry.attributes = old.attributes;
          if (!Object.keys(carry).length) return true;
          return fetchCartJson('cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(carry)
          })
            .then(function () {
              return true;
            })
            .catch(function () {
              return true;
            });
        });
      });
  }

  /**
   * One add, with a single verified retry.
   *
   * Only an add that came back with an HTTP status is retried: that proves the
   * request reached Shopify and was refused, so nothing was put in the cart and
   * replaying it cannot duplicate a line. A timeout or a dropped connection is
   * never retried, because the add may have landed after all.
   */
  function addOnceWithRecovery(variantId, quantity, options) {
    return withTimeout(addToCartRequest(variantId, quantity, options), 12000).catch(function (err) {
      if (!cartErrorHadResponse(err)) throw err;

      return liveVariantAvailable(variantId).then(function (available) {
        if (available === false) throw err; // genuinely sold out — report it as such

        // Shopify says sold out, the storefront says in stock: the cart session
        // itself is refusing everything. Give the customer a fresh one.
        if (available === true && isStockCartError(err)) {
          return rebuildCartSession().then(function (rebuilt) {
            if (!rebuilt) throw err;
            return withTimeout(addToCartRequest(variantId, quantity, options), 12000).catch(function (err2) {
              if (err2 && typeof err2 === 'object') {
                try {
                  err2.__mmStockVerifiedAvailable = true;
                } catch (e) {}
              }
              throw err2;
            });
          });
        }

        return cartPause(600).then(function () {
          return withTimeout(addToCartRequest(variantId, quantity, options), 12000).catch(function (err2) {
            if (available === true && err2 && typeof err2 === 'object') {
              try {
                err2.__mmStockVerifiedAvailable = true;
              } catch (e) {
                /* frozen error object — fall through with the original wording */
              }
            }
            throw err2;
          });
        });
      });
    });
  }

  function add(variantId, quantity, options) {
    options = options || {};
    var sourceEl = options.sourceElement || null;
    if (sourceEl && sourceEl._mmAtcJob) return sourceEl._mmAtcJob;

    clearSourceError(sourceEl);
    setAtcBusy(sourceEl, true);

    var job = pendingAddChain.then(function () {
      return addOnceWithRecovery(variantId, quantity, options);
    });

    // A rejected add used to end with the button quietly un-busying and no
    // feedback at all, which is what "add to cart does nothing" looked like in
    // browsers that block cookies or drop the request. Always tell the customer.
    job.catch(function (err) {
      var text = explainCartError(err);
      showSourceError(sourceEl, text);

      // showSheetToast silently no-ops when the sheet markup is absent, so only
      // use it when its banner is actually in the DOM.
      if ($('#mmCartSheetSuccess') && $('#mmCartSheetSuccessText')) {
        showSheetToast(text, 'error');
      } else if (window.MMCompatUI && window.MMCompatUI.toast) {
        window.MMCompatUI.toast(text, true);
      } else if (window.MMShop && window.MMShop.showToast) {
        window.MMShop.showToast(text, true);
      }
      if (window.MMCompat) window.MMCompat.report(err, 'MMCart.add');
    });

    pendingAddChain = job.catch(function () {});
    if (sourceEl) sourceEl._mmAtcJob = job;
    return job.finally(function () {
      setAtcBusy(sourceEl, false);
      if (sourceEl) sourceEl._mmAtcJob = null;
    });
  }

  var ATC_FAST_SEL = [
    '.mmupi-atc',
    '.mmupi-sticky-atc',
    '.mmupi-bar-atc',
    '.mmupi-fbt-add',
    '.mmupi-bogo-banner__btn',
    '.mmshop-add-btn',
    '.mms-add-btn',
    '.mm-col-add-btn',
    '.mmpi-atc',
    '.mmpim-atc',
    '.mmo-atc',
    '.mm-feed-atc',
    '.mm-pop-atc-btn',
    '.mm-op-atc-btn',
    '.mm-smart-add-btn',
    '.mm-ymal-card__add',
    '.mm-cart-sheet__rec-add',
    '.mmh-carousel-card__add',
    '.mmh-product__add',
    '.mmh-offer__add',
    '[data-mmh-add]',
    'button[name="add"]',
    '.quick-add__button'
  ].join(',');

  function hookFastAtcButtons() {
    if (window.__mmAtcFastBound) return;
    window.__mmAtcFastBound = true;

    // An add error belongs to the selected variant. Remove it as soon as the
    // customer makes a different selection so a stale sold-out message cannot
    // appear to describe the newly selected option.
    document.addEventListener('change', function (e) {
      var field = e.target;
      if (!field || !field.matches) return;
      if (field.matches('#mmupiBarVariant, .mmupi-v-select, select[name="id"], [data-product-variant-select]')) {
        clearProductSelectionErrors();
      }
    }, true);

    document.addEventListener('click', function (e) {
      var option = e.target && e.target.closest ? e.target.closest('.mmupi-var-opt, [data-variant-id]') : null;
      if (option) clearProductSelectionErrors();
    }, true);

    document.addEventListener(
      'pointerdown',
      function (e) {
        if (e.button != null && e.button !== 0) return;
        var btn = e.target && e.target.closest ? e.target.closest(ATC_FAST_SEL) : null;
        if (!btn || btn.disabled || btn.classList.contains('mm-atc-busy')) return;
        btn.classList.add('mm-atc-press');
      },
      true
    );

    function clearPress(e) {
      var btn = e.target && e.target.closest ? e.target.closest(ATC_FAST_SEL) : null;
      if (btn) btn.classList.remove('mm-atc-press');
    }

    document.addEventListener('pointerup', clearPress, true);
    document.addEventListener('pointercancel', clearPress, true);
  }

  /**
   * A 422 add came back. If Shopify blamed stock but the storefront still lists
   * the variant as available, the cart token is the problem, not the product —
   * replace it so the customer is not locked out of the whole catalogue.
   */
  /** First variant id in a cart/add.js request body, whatever shape it used. */
  function variantIdFromAddRequest(init) {
    var body = init && init.body;
    if (typeof body !== 'string') return 0;
    try {
      var parsed = JSON.parse(body);
      if (parsed && parsed.id) return parseInt(parsed.id, 10) || 0;
      if (parsed && Array.isArray(parsed.items) && parsed.items.length) {
        return parseInt(parsed.items[0].id, 10) || 0;
      }
    } catch (e) {
      var match = body.match(/(?:^|&)id=(\d+)/);
      if (match) return parseInt(match[1], 10) || 0;
    }
    return 0;
  }

  function healPoisonedCartSession(response, variantId) {
    if (cartSessionRebuilt || !variantId) return;
    response
      .json()
      .then(function (data) {
        if (!data) return;
        data.status = data.status || 422;
        if (!isStockCartError(data)) return;
        return liveVariantAvailable(variantId).then(function (available) {
          if (available !== true) return;
          return rebuildCartSession().then(function () {
            showSheetToast(
              compatText('cart_retry', 'Could not add the item just now. Please try again.'),
              'error'
            );
          });
        });
      })
      .catch(function () {});
  }

  function hookGlobalAddToCart() {
    if (window.__mmCartHooked) return;
    window.__mmCartHooked = true;

    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);

      return origFetch.apply(this, arguments).then(function (res) {
        // Several widgets post to cart/add.js directly instead of going through
        // MMCart.add, so they never see the verified retry. Heal the session for
        // them here: the failed click is lost, but the next one works instead of
        // the customer hitting "sold out" on every product from now on.
        if (isAdd && !res.ok && res.status === 422 && !skipGlobalHook) {
          healPoisonedCartSession(res.clone(), variantIdFromAddRequest(init));
        }

        if (!isAdd || !res.ok || skipGlobalHook || window.__mmTierGiftCartOps || !root) return res;

        res
          .clone()
          .json()
          .then(function (data) {
            return fetchCart().then(function (cart) {
              updateBadges(cart.item_count, true);
              lastRecsKey = '';
              applyCartUpdate(cart, { forceRecs: true, loadRecs: true });
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
              showSuccessBanner(data.product_title || data.title || '');
              if (!isOpen) open({ skipRefresh: true, cart: cart });
            });
          })
          .catch(function () {});

        return res;
      });
    };

    var XHR = window.XMLHttpRequest;
    var origOpen = XHR.prototype.open;
    var origSend = XHR.prototype.send;

    XHR.prototype.open = function (method, url) {
      this._mmCartUrl = url || '';
      this._mmCartMethod = (method || '').toUpperCase();
      return origOpen.apply(this, arguments);
    };

    XHR.prototype.send = function () {
      var xhr = this;
      var url = xhr._mmCartUrl || '';
      var isAdd = xhr._mmCartMethod === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url);

      if (isAdd) {
        xhr.addEventListener('load', function () {
          if (skipGlobalHook || window.__mmTierGiftCartOps || !root || xhr.status < 200 || xhr.status >= 300) return;
          fetchCart().then(function (cart) {
            updateBadges(cart.item_count, true);
            lastRecsKey = '';
            applyCartUpdate(cart, { forceRecs: true, loadRecs: true });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            showSuccessBanner('');
            if (!isOpen) open({ skipRefresh: true, cart: cart });
          });
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  function bindTriggers() {
    document.querySelectorAll('[data-mm-cart-trigger]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    document.querySelectorAll('[data-mm-cart-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    var clearAllBtn = $('#mmCartSheetClearAll');
    if (clearAllBtn && clearAllBtn.dataset.mmClearWired !== '1') {
      clearAllBtn.dataset.mmClearWired = '1';
      clearAllBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearAllCart();
      });
    }

    var continueBtn = $('#mmCartSheetContinue');
    if (continueBtn) {
      continueBtn.addEventListener('click', close);
    }

    var wheelBtn = $('#mmCartSheetWheelBtn');
    if (wheelBtn) {
      if (!wheelBtn.getAttribute('data-mm-wheel-title')) {
        wheelBtn.setAttribute('data-mm-wheel-title', wheelBtn.getAttribute('title') || '');
      }
      wheelBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        try {
          if (window.MMWheelLauncher && typeof window.MMWheelLauncher.open === 'function') {
            var result = window.MMWheelLauncher.open();
            if (result && typeof result.then === 'function') result.catch(function () {});
            return;
          }
        } catch (err) {}
        var launch = document.getElementById('mm-launch-btn');
        if (launch) {
          try { launch.click(); } catch (e2) {}
        }
      });
    }

    var giftBtn = $('#mmCartSheetGiftBtn');
    if (giftBtn) {
      giftBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        handleGiftAction();
      });
    }

    var giftPerk = $('#mmCartSheetGift');
    if (giftPerk && giftPerk.dataset.mmGiftPerkWired !== '1') {
      giftPerk.dataset.mmGiftPerkWired = '1';
      giftPerk.style.cursor = 'pointer';
      giftPerk.setAttribute('role', 'button');
      giftPerk.setAttribute('tabindex', '0');
      giftPerk.addEventListener('click', function (e) {
        if (e.target.closest('a, button, input, select, textarea, summary')) return;
        e.preventDefault();
        e.stopPropagation();
        handleGiftAction();
      });
      giftPerk.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        handleGiftAction();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var focusable = $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])', root)
        .filter(function (el) { return !el.hidden && el.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function initSmartRecsContainers() {
    document.querySelectorAll('[data-mm-smart-recs]').forEach(function (container) {
      if (container.dataset.mmRecsLoaded) return;
      container.dataset.mmRecsLoaded = '1';

      var productId = container.getAttribute('data-product-id');
      var limit = parseInt(container.getAttribute('data-limit'), 10) || 4;
      var excludeId = parseInt(container.getAttribute('data-exclude-id'), 10);

      function renderFbt(products) {
        var filtered = products.filter(function (p) {
          return p.id !== excludeId;
        });
        if (!filtered.length) {
          container.innerHTML = '';
          container.closest('.mmupi-fbt')?.remove();
          return;
        }

        var addLabel = CFG.recAdd || '+ Add';
        var html = '';
        filtered.slice(0, limit).forEach(function (p) {
          var v =
            (p.variants && p.variants.find(function (x) {
              return x.available;
            })) ||
            p.variants[0];
          if (!v) return;
          var img = p.featured_image;
          if (typeof img === 'string') {
            /* ok */
          } else if (img && img.src) {
            img = img.src;
          } else {
            img = '';
          }
          var price = v.price;
          html +=
            '<div class="mmupi-fbt-item" data-fbt-source="shopify-api">' +
            '<div class="mmupi-fbt-img"><a href="' +
            escapeHtml(productPageUrl(p)) +
            '"><img src="' +
            escapeHtml(img) +
            '" alt="' +
            escapeHtml(p.title) +
            '" loading="lazy" width="100" height="100"></a></div>' +
            '<div class="mmupi-fbt-info"><p class="mmupi-fbt-name">' +
            escapeHtml(p.title.length > 35 ? p.title.slice(0, 35) + '…' : p.title) +
            '</p><span class="mmupi-fbt-price">' +
            formatMoney(price) +
            '</span></div>' +
            '<button type="button" class="mmupi-fbt-add" data-variant-id="' +
            v.id +
            '">' +
            escapeHtml(addLabel) +
            '</button></div>';
        });
        container.innerHTML = html;

        container.querySelectorAll('.mmupi-fbt-add').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
            if (!vid) return;
            var orig = btn.textContent;
            btn.disabled = true;
            btn.classList.add('mm-atc-busy');
            add(vid, 1, { sourceElement: btn }).finally(function () {
              btn.classList.remove('mm-atc-busy');
              btn.textContent = '✓';
              btn.style.background = '#10B981';
              setTimeout(function () {
                btn.textContent = orig;
                btn.style.background = '';
                btn.disabled = false;
              }, 1400);
            });
          });
        });
      }

      fetchRecommendations([productId], limit + 2).then(renderFbt);
    });
  }

  function init() {
    root = document.getElementById('mm-cart-sheet');
    if (!root) {
      console.warn('[MMCart] #mm-cart-sheet not found — is theme.liquid rendering mm-cart-sheet snippet?');
      return;
    }
    if (root.parentNode !== document.body) {
      document.body.appendChild(root);
    }
    hookGlobalAddToCart();
    hookFastAtcButtons();
    bindTriggers();
    bindCartActions();
    initSmartRecsContainers();

    updateSdd();
    if (sddTimer) clearInterval(sddTimer);
    sddTimer = setInterval(updateSdd, 1000);

    fetchCart().then(function (cart) {
      cartCache = cart;
      if (cart.items && cart.items.length) {
        updateFooterTotals(cart);
        renderIncentives(cart);
        renderDiscounts(cart);
        maybeLoadRecs(cart, true);
      }
      try {
        if (sessionStorage.getItem('mm_open_cart') === '1') {
          sessionStorage.removeItem('mm_open_cart');
          setTimeout(function () { open({ skipRefresh: true, cart: cart }); }, 120);
        }
      } catch (e) {}
    });

    document.addEventListener('cart:refresh', refresh);
    window.addEventListener('mm:currency-change', function () {
      updateSdd();
      if (cartCache) {
        renderIncentives(cartCache);
        renderDiscounts(cartCache);
      }
    });
  }

  function forceSheetUpdatingOff() {
    sheetUpdatingCount = 0;
    var el = $('#mmCartSheetUpdating');
    var panel = root && root.querySelector('.mm-cart-sheet__panel');
    var msgEl = $('#mmCartSheetUpdatingMsg');
    if (msgEl) msgEl.textContent = CFG.updating || 'Updating cart…';
    if (el) {
      el.hidden = true;
      el.setAttribute('aria-busy', 'false');
    }
    if (panel) panel.classList.remove('is-updating');
    if (root) root.classList.remove('mm-cart-sheet--busy');
  }

  function runWithoutHook(fn) {
    skipGlobalHook = true;
    return Promise.resolve().then(fn).finally(function () {
      skipGlobalHook = false;
    });
  }

  function runCartMutation(fn) {
    var job = cartMutChain.then(function () {
      return cartPause(50).then(function () {
        return runWithoutHook(fn);
      });
    });
    cartMutChain = job.catch(function () {});
    return job;
  }

  function waitForCartIdle(maxMs) {
    maxMs = maxMs || 4000;
    var start = Date.now();
    return new Promise(function (resolve) {
      function tick() {
        if (!hasPendingLineOps()) {
          resolve();
          return;
        }
        if (Date.now() - start >= maxMs) {
          resolve();
          return;
        }
        setTimeout(tick, 60);
      }
      tick();
    });
  }

  function hasPendingLineOps() {
    return Object.keys(pendingKeys).length > 0;
  }

  window.MMCart = {
    add: add,
    setButtonBusy: setAtcBusy,
    open: open,
    close: close,
    refresh: refresh,
    updateBadges: updateBadges,
    cartApi: cartApi,
    runWithoutHook: runWithoutHook,
    runCartMutation: runCartMutation,
    waitForCartIdle: waitForCartIdle,
    applyUpdate: applyCartUpdate,
    getCart: function () { return cartCache; },
    fetchCart: fetchCart,
    hasPendingLineOps: hasPendingLineOps,
    getLastLineOpAt: function () { return lastUserLineOpAt; },
    setSheetUpdating: setSheetUpdating,
    clearSheetUpdating: forceSheetUpdatingOff,
    showToast: showSheetToast,
    rebuildSession: rebuildCartSession,
    explainError: explainCartError,
    describeDiscountFailure: describeDiscountFailure,
    removeDiscount: removeDiscount,
    cartDiscountCodes: cartDiscountCodes
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
